module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "عزيزي-القارئ"
    }
  }, [_c('h1'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جرَت أحداثُ القصّة في تلك الحقبة الزمنية، وبطلاتُها ثلاثُ شابَّاتٍ في عُمر الزهور، مُقبلات على الحياة، لكلّ منهنَّ صفاتٌ جميلة تميّزُها عن الأخرى؛ فـلؤلؤة قويَّة الشخصية، كما تتمتَّعُ بالأدب والعقل الرّاجح، أمّا جمانة؛ فلديها روحٌ جميلةٌ تتمتَّع بالفكاهة والهدوء معًا، وأمّا صوفيا؛ فتتمتَّع بالنعومةِ والصفاء، كما تتمتَّعُ بالجاذبية وروح المغامرة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ترى الشابات الثلاث الحياة من زاويتهنّ الخيالية، ولا يعلمن بأنَّ للحياةِ زوايا كثيرة، بعضها مُظلم، وبعضها مضيء، وبعضها غامض كغموض الشَّمس، ولم يخطر في بالهنَّ أنَّ هناك خبايا وراءَ هذا العالم تنتظرهنّ، وعلى الرّغمِ من فقر عائلتهنَّ؛ فإنّهنّ تربّينَ تربيةً سليمةً على يد أبوَين يُقدِّران بعضهما بعضًا، وقد جرتِ الأحداثُ سريعةً، أسرع ممّا توقّعنا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("يُحكى إنَّ عائلة فقيرة كانت تعيش في قرية تقعُ في شمالي بلاد بعيدة، يُطلق عليها بلاد القمر المضيء، وسُمّيت بذلك لأنّ قمرَها مضيءٌ دائمًا، وكانت هذه العائلة تعيش في ضنكٍ من شدة الفقر، ولديها ثلاثُ شابَّات غاية في الجمال، ولكلِّ واحدة منهنّ صفاتها الَّتي تميِّزُها عن الأخرى، ولكنْ من سوء حظهنَّ أنّهنَّ من تلك البلاد البعيدة والفقيرة، فلَم ينعمنَ بالعيش الرغيد، بل بالتعبِ والشقاء والعمل مع أبيهنّ في الحقول حتَّى كبرْنَ، والأدهى والأمرُّ أنَّ حاكِم تلك البلاد ظالمٌ؛ يأمرُ جنودَه بين فينة وأخرى بأنْ تُجلَب إليهِ أجملُ بنات القرية؛ ليأخذهنَّ سبايا له.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("منذ أن كبرَت الفتياتُ وكان جمالهنَّ لافتًا، أصبح أبوهنَّ لا يسمح لهنَّ بالخروج من بيتهم الصغير المتواضع من شدَّة خوفه عليهنّ؛ فلا يستطعنَ رؤية القرية وعشبها الأخضر وسمائها الصافية إلّا في اللَّيل بعد أنْ يحلَّ الظلام ويزداد نورُ القمر وينام جميعُ النَّاس ويخلو الطريق؛ فيهدأ المكان ثمَّ يخرجنَ إلى أمام البيت الصغير ويجلسنَ يتسامرن.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تتساءل الشاباتُ الثلاث: لؤلؤة، وجمانة، وخاصّةً الصغرى صوفيا كثيرًا عن هذه الحياة الَّتي ليس فيها روح، فما هذه العيشة الصعبة؟! ما هذا الحال البائس؟! لقد سئمن هذه الحياة؛ أردنَ الخروج الأبدي، والهرب إلى مكان بعيد، رُبّما هناك عالم آخر جميل وآمن، رُبّما هناك حياة مختلفة، لا بدّ من أنْ يرينَ النّورَ من بعد الظلام.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كانت تلك القرية بعيدة نوعًا ما عن باقي القرى والبلاد الأخرى، بل تكادُ تكون منعزلةً، وعلى")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الرغم من جمال المكان، حيث يتلألأ كلُّ شيء وخاصّة في الليل؛ فإنّهنَّ يرينَهُ باهتًا مظلمًا!")])]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("****")])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في إحدى اللَّيالي، جلستِ الشاباتُ يتسامرنَ:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جمانة: إلى متى سنبقى على هذا الحال؟! لا أستطيع أنْ أُكملَ حياتي في هذا المكان وبهذه الطريقة! ليست كلّ البنات يعاملن مثلنا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة: نعم، صدقتِ، ولكنَّ أبانا يخاف علينا كثيرًا، وهو يتعب من أجلنا!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جمانة: ولكنْ إلى متى؟! هل سنبقى حتَّى تتزوّج كلٌّ منّا رجلًا فقيرًا مثلنا ونكملَ العيشَ بهذه الطَّريقة، وفي هذا المكان؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة: العالَم كلُّه ليس كقريتنا؛ رُبّما هناك حياة مختلفة، ولكنْ ماذا نفعل؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا: نهربُ!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة وجمانة، مَصدومتَان: نهربُ! إلى أين؟! ما هذا الكلام؟! هل فكَّرتِ في أبينا وفي أُمّنا؟! ماذا سيحصلُ لهما؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا: ليحصل ما يحصل! لقد تحدَّثتُ إلى أبي مرارًا وتكرارًا في هذا الأمر ولكنْ من دون جدوى؛ فهو اعتاد العمل كلَّ يومٍ، وأصبح الشَّقاءُ يُلازمه، وأمُّنا كذلك لا تريد تغييرَ أيّ شيء، الشَّيءُ الوحيد الَّذي تريده هو أنْ نتزوج ويرتاح قلبها وتطمئن علينا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وقفَت صوفيا منُزعجةً، ورمقتهما بنظرةٍ، كأنّها تنوي شيئًا ما، ثمّ دخلَت البيتَ، ولحقَتها لؤلؤة وجمانة، ثمّ استلقينَ للنَّوم، وذهبَ تفكيرُ كلِّ واحدة في طريق.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا لم تستطِع النَّومَ؛ اتّخذَت قرارَها ولن تتراجع عنه، ولكنْ كيف؟! أمّا جمانة، فقد استغرقَت في نوم عميق، وأمّا لؤلؤة، فقد اعتراها الخوفُ من تفكير أختَيها وعدم استسلامهما إلى الحياة الَّتي خُلقنَ فيها، ثمّ غطّت في نومٍ عميقٍ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في الصّباحِ، وكالعادة، ذهبَ الأب إلى عمله في الحقل، وهُنّ جلسنَ مع أُمّهنَّ يساعدْنَها في أعمال البيت:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا: إلى متى ونحن على هذا الحال يا أُمّي؟! أمَا آن الأوانُ لنغيّر من حالنا؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأُم: لا نستطيعُ أنْ نغيّرَ من حالنا؛ هذه حياتنا الَّتي خُلقْنا فيها، وسيجري علينا ما جرى على النَّاس مِن قبلنا!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جمانة: لماذا نرضى بما جرى للنَّاس من قبلنا؟! أمَا آن الأوان لنخرج من هذهِ القرية، كما فعل بعضُ جيراننا؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأُم: إلى أين ذهبوا؟! وكيف هي حياتُهم اليوم؟! هل تعلمْنَ إن كانوا سعداءَ أم أشقياء؟! أتُرِدْنَ أنْ نذهبَ إلى المجهول؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا: لا نعلمُ، ولكنْ مِن المؤكَّدِ أنّهم في حالٍ أفضل.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأُم: حينما يعودُ أبوكنَّ تحدَّثنَ إليه، لا دخلَ لي في شيء، أُريد أنْ أعيشَ معكم بأمانٍ فقط.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة على الرّغم مِن أنّها لا توافقهما الرّأي؛ فإنَّها تدركُ أنّ هناك حياةً مختلفة وراء تلك الجبال الشَّاهِقة:")])]), _c('br'), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لقد كبرنا يا أُمّي، كانَ اللَّعبُ بالدُّمى الَّتي كنتِ تخيطينها لنا يستهوينا، وكذلك اللَّعب بالحِجارةِ على سفح الجبل القريبِ، كانَت أقلُّ الأشياء تُفرحُنا، ننطلقُ ونلعب هنا وهناك، ولكنْ اختلف كلُّ شيء!")])])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بعدَ عودة الأب، جلسَت إليه الأُم تُحدّثُه وهي تُقدِّمُ إليه الطعام عن تركِ هذه القرية الصغيرة من أجل بناتهما:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لقد سئمنا العيشَ هنا!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سكتَ برهةً، ثمّ قال:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هل تعلمين بأنّي أفكّر في هذا الأمر منذ زمن قريب؟!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تهلّلَ وجهُ الأُمّ بعدما كانَت خائفةً جدًّا من الحديث إليه في هذا الأمر، وسمعَت صوفيا ذلك؛ فأتَت مُسرعةً:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا: أحقًّا يا أبي؟! أرجوكَ!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأب: ما دامَت رغبتُكنَّ في هذا الأمرِ فلنرحَل، ولكنْ اتركْنَني أُرتِّب الأمور في الأيّام المُقبِلة، لقد كبرتُ ولم أعُد أقوَى على العمل في الحقول.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تهلَّلتْ وجوهُ الشَّابات الجميلات، وبدَت الابتسامةُ عليها والسعادة على محيّاهنّ واضحة، ولم ينمنَ تلك الليلة من شدة الفرح، بل أمضينها يتحدّثن عن أحلامهنّ: تارةً عن حياة ورديةٍ لا تشبه هذه الحياة تتراءى أمام أعينهنّ، وتارةً أُخرى عن زوج المستقبل، وعن أطفال بجمال")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الورد، وعن حياة لا تشبه هذه الحياة!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة: لا تذهبَا بعيدًا بأحلامكما؛ يمكن أنْ تتغيَّر حياتُكما، ولكنْ ليس بالدرجة الكبيرة الَّتي تتمنيانِها!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مضَت أسابيعُ معدوداتٌ والعائلةُ تستعدُّ للرَّحيل، جهّزوا ما يحتاجون إليه، والأخوات في غاية الفرح، وقف الأب أمام البيت الصغير يطيلُ النظر وعيناه يبدو فيهما الحزنُ؛ فقد مرَّ عليه عمرٌ وهو يعيش في هذا المكان، ولولا خوفُه على بناتهِ لمَا فكَّر في الرحيل.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كانت الطُّرق في ذاك الزمان وعرةً، والوسيلة الوحيدة للنَّقل عرباتُ الحمير أو الخيول.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مع طلوع الفجر والظلام لا يزال يُخيِّمُ على القرية، مشوا إلى أقرب طريقٍ من بيتهم الصّغير، وقفُوا ينتظرون مَنْ يُقلّهم، عادةً، هذه الطرق تمرُّ بها العربات المحمّلة بالبضائع من مدينة الى أخرى ومن قرية إلى أخرى.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ما لبثت أنْ وصلت عربةٌ يقودُها رجل متوسط العمر، شاحِب الوجه، كث اللحية، أشار إليه الأب بالوقوفِ فوقَفَ، بدَت لهجتُه غير واضحة، ولكنْ استطاع الأب أنْ يُفهِمه بأنّهم يريدون أنْ يركبوا معهُ، وأشار إليهم بالركوب، فركبوا جميعًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأب في ترقُّب، والفتيات تغمرهنَّ الفرحةُ:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أخيرًا! ها نحن نتركُ هذه القرية الصغيرة.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("استطاع الأب أنْ يَفهم من الرجل سؤاله:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إلى أين تذهبون؟")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فأشار إليه أنْ يمضِي في طريقِه ليصلَ إلى أقرب مدينة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("خيّمَ الصمت عليهم جميعًا، قطعوا مسافةً ليست بالقصيرة إلى أنْ دخلُوا بين جبالٍ ووديان؛ بدا المكانُ موحِشًا، نظرَتِ الأمّ إلى بناتِها بخوفٍ، كمَا لاحظَتِ الخوف على محيّاهنَّ، ولكنْ ما لبثَ الرَّجل أنْ أوقفَ العربةَ؛ فأشارَ إليه الأبُ: لماذا؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فأشارَ الرَّجل إلى أنّ الحميرَ مُتعبةٌ وستشرب الماءَ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تركَ الرجل المكانَ بعدما شربت الحميرُ، وأخذ يتمشّى قليلًا:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأُمّ: لماذا تركَنا وحدنا في هذا المكان؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأب: لا عليكِ؛ رُبّما يريدُ أنْ يقضي حاجته.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جلسوا جميعًا في انتظارِ الرَّجلِ، ولكنَّ الانتظار طال، حتَّى هجمَت عليهم مجموعة من الرجال الملثّمين؛ أَهُم لصوص أم قطّاع الطّرق؟! لا يعلمون، ولكنْ حدثَ كلُّ شيء بسرعة، ضربُوا الأب والأُمَّ، وجرّوا الشابات الثلاث جرًّا، ومَن تتجرّأ وتصرخُ تُضرَب في كُلِّ مكانٍ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ما هذا الَّذي يحدث؟! يكادُ يكونُ حلمًا، بل كابوسًا، شيء لم يكُن في الحسبانِ، جرَتِ الأحداث سريعةً وفي صراخ يكادُ يختفي بين الجبال، أوصلوهنَّ إلى قلعةٍ كبيرة أشبه بقصر يُحيطها الحُرَّاس من كلّ جانب، قاموا بتسليمهنَّ للحرس؛ فانطلقوا وذهبوا بهنَّ إلى سجنٍ كبيرٍ مُظلم لا يكدنَ يرينَ بعضهنّ بعضًا، لا يُسمَع منهنّ إلّا البكاء والنحيب:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أين أبي وأُمِّي؟! مَنْ أنتُم؟! لماذا نحن هنا؟!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في تلك الأثناء، أتى رجلٌ ضخم الجثَّة وبيديه مصباح يتحسّس به وجوههنَّ وهنَّ في خوف شديد وهلع واضح على محيّاهنّ، جمانة، تصرخُ به:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مَنْ أنت؟! أين نحن؟! أينَ أبي وأُمّي؟!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الرّجل، يصرخُ في وجهها: اصمتي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("غادرَ الرّجل، ونامَتِ الفتياتُ من التَّعب والخوف وهنَّ مُلتصقات ببعضهنّ البعض والدموع قد جفَّت على وجناتهنَّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في الصّباح، رمى إليهنَّ حارسُ السجن ببعض الطعام، وبعد برهة، أتى الرّجل الضخم مرّة أخرى، ولكنْ هذه المرّة تختبئ خلفَه امرأة؛ فقال لها:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ادخلي هيّا!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("دخلَت عليهنّ، وظلّت واقفةً تُطيل النَّظرَ في وجوههنّ؛ فقالت: ما هذا الجمال يا بنات؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم تردَّ عليها أيٌّ منهنّ؛ فأكملَت وقد أشارَت إلى صوفيا:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تعالي أنتِ!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فرفضت الانصياع، وأخذَت تصرخُ:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إلى أينَ ستأخذينني؟!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سحبَتها بقوّة من يديها وجرّتها إليها جرًّا وهي تصرخ وتصرخُ معَها أُختاها؛ فأمسكَ بهما الرَّجل، وأخرجَتِ المرأةُ صوفيا معها، وهي تجرُّ رجليها جرًّا وتنظرُ خلفَها ودموعُها تتطاير من عينيها، أفلَت الرَّجل الأُختَيْن وأقفلَ عليهما باب السجن مرّة أخرى.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أخذَت المرأةُ صوفيا في ممرّات القلعة الكبيرة، ووقفَت بها أمام باب كبير فأدخلتها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("المرأة: هذه غرفتُكِ، وهناك حمّام؛ اذهبي واغتسلي وبدِّلي ملابسكِ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا، تصرخُ بها: أين أنا؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("المرأة: لا يحقُّ لكِ السؤال، افعلي فقط ما آمركِ به.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جلسَت صوفيا على الأرض تبكي وتمسِكُ رأسها، وكلّ الأحداث تدور أمامها:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هَل أنا أحلم؟!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جرّتِ المرأةُ صوفيا مرّة أخرى:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قِفي، وافعلي ما آمركِ به، لقَد دفعَ ثمنكِ الأميرُ.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا: ماذا؟! دفعَ ثمني! ماذا تقولين؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("المرأة، وهي تدفعها إلى الحمّام:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لا تُقاومي، افعلي فقط ما أطلبه منكِ، أنتِ مجرد جارية هنا.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا، وهي تنتحبُ وتلطم وجهها الجميل:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جارية! أنا لستُ جاريةً!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("دخلَت صوفيا تغتسل، ودموعها تكاد لا تتوقَّف، وأطالَت؛ فدخلت عليها المرأة:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ماذا دهاكِ يا فتاة؟! اخرجي والبسي الملابس النظيفة.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("خرجَت صوفيا وهي ترتدي الملابس الَّتي وضعَتها لها المرأة، وجلسَت على أريكة في جانب الغرفة الكبيرة الواسعة تنتظر ما تريد منها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("دخلَت المرأة مرّة أخرى وقالت:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هيَّا معي، اتبعيني.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا: إلى أين؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("المرأةُ: اشش!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تبعَت صوفيا المرأةَ في خوف، عبر ممرّات طويلةٍ متعرّجة لا نهاية لها، إلى أن وصلَتا إلى باب حديدي له حلقة دائرية كبيرة؛ فأمسكَت به المرأة وطرقَت الباب ثلاث طرقات، ثمّ همّت بالذهاب، لكنَّ صوفيا تمسكُ بالمرأة وتقول:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إلى أينَ ستذهبين وتتركينني في هذا المكان؟!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("المرأة، وهي تدفعُها إلى الباب:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قِفي؛ لا تتحرَّكي.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ابتعدت المرأةُ، وفُتِح الباب، وإذا بشابٍ طويل في أواخر الثلاثين من عمره يقفُ خلفَه؛ فأمرَ صوفيا بالدّخول، ظلّت واقفةً خائفة ترتجف؛ فأمرها مرّة أخرى بالدخول.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("دخلت صوفيا تجرّ الخطى، وعيناها تدوران في المكان، الَّذي بدا غرفة أكبر بكثير من تلك الغرفة، وبزخرفة ووسائد ملوّنة في كلّ زاوية، أشارَ إليها بالجلوس على أوّل أريكةٍ تقابلها، وجلس هو على أريكة أخرى، وبعدما طال الصّمت، قالَ")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الشّاب:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ما اسمُكِ؟")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("اسم جميل، لماذا أنتِ خائفة؟!")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم تردَّ صوفيا على الشاب بأي كلمة؛ فسبب خوفها واضح؛ كيف لا تخافُ وهي في مكان غريب ومع رجل غريب، ومنذُ ساعات فقدَت أبوَيها ولا تعرف مصيرهما ولا مصير أُختَيْها اللَّتين في السجن؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نهضَ الشّاب واقترب من صوفيا؛ ربَّت على رأسها، بدا لطيفًا، ولم يعاملْها بعُنف كما فعلَ الرجل الضخم والمرأة الغريبة، لم يترك لها حريَّة القرار؛ هي هنا أسيرة أو جارية لا حقَّ لها في الاعتراض أو الصراخ أو المقاومة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بعد ساعة طُرِقَ الباب؛ فأشار الشاب إلى صوفيا:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("اخرجي.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لمّا فتحَت صوفيا الباب وخرجَت، أمسكَت بها المرأة الَّتي كانت تنتظرها، وذهبت بها إلى الغرفة الأولى وأدخلَتها وأقفلَت الباب عليها، رمَت بنفسها وبجسدها على السرير الوثير ودموعها تبلل خدّيها، ثمّ غطّت في نوم عميق، ولم تستيقظ إلّا على رعْنَة الشمس الَّتي دخلت عليها من نافذة الغرفة الضيقة كأنّها تجفّف دموعها على استحياء.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("دخلت المرأة: أمَا زلتِ نائمة؟! انهضي واغتسلي، سيُجلَب لكِ الإفطار.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا: أين أنا؟! ماذا يحدث؟! أريدُ أن أفهمَ؛ أين أُختاي؟!")])]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("****")])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في جانب آخر، حدث لـجمانة – الأُخت الوسطى – ما حدث لـصوفيا؛ فقد دخل الرجل الضخمُ السجنَ تتبعه امرأةٌ أخرى، أخذَت تجرُّها من يديها وتقولُ:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قومي معي.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جمانة، تصرخُ: إلى أين تأخذينني؟! أين أُختي؟! أين صوفيا؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة، تتعلّقُ بأُختها وتصرخ:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("اتركوها؛ اتركوا أُختي، إلى أين تأخذونها؟!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم يردَّ عليهما أحد، واستمرّت المرأة في جرّ جمانة، كما وقفَ الرجل الضخم في وجه لؤلؤة ومنعَها من اللَّحاق بأُختها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("اختفت جمانة في ممرّات القلعة وهي تجرّ الخطى مع هذه المرأة القوية، الَّتي لا تستطيع أنْ تفلت يديها منها، أدخلَتها غرفة واسعة، وطلبت منها أنْ تغتسلَ وتُبدِّل ملابسها، كما طُلب من صوفيا تمامًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جلست جمانة على الأريكة تبكي خائفةً ممّا سيحدث لها، وما ينتظرها مستقبلًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("غادرَتِ المرأة، ثمّ عادت ووجدَت جمانة على حالها؛ فانزعجت منها، وهدّدتها بالرجل الضخم إنْ لم تستجبْ؛ فنهضت واغتسلت، وكانت دموعها تنهمر ممزوجة بالماء، أحسّت بقليل من الراحة؛ فسبحان مَنْ خلق الماء الَّذي يغسل القلوب قبل الأبدان! ثمّ بدَّلَت ملابسها، وخرجَت لتجلس على الأريكة في انتظار ما سيحلُّ عليها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كان الهدوء يعمّ المكان؛ صمت رهيب، وظلمة كالحة أيضًا، وعلى الرغم من ظهور الشمس؛ فإنّ نورها يكادُ لا يتسلل من النوافذ العالية، تبدو القلعة مهجورةً، أو رُبّما من ضخامتها لا يرى فيها أحدهم الآخر، إنّها أشبه بقصر قديم قد هجرَه سكَّانُه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لا يكاد تفكير جمانة في غرابة المكان يتسلّل إلى عقلها، وإذا بها تسمع خطوات قفزت معها دقّات قلبها، دخلَت المرأة هذه المرّة ومعها اثنان من الحرس؛ ما هذا المكان الغريب؟! قالَا لها:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هيَّا معنا!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ولم تستطِع التحرُّك؛ فأمسكاها من يديها، وذهبت معهما من دون مقاومة؛ فقد أخذ منها التعب مأخذه، كان هناك قافلة واقفة خارجًا؛ فأمراها بالركوب معهما، وهي في ذهولٍ، وركبَت مع مجموعة من النساء والرجال يلفُّهم الصّمت الرهيب.")])]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("****")])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تؤخذ صوفيا كلَّ ليلة إلى ذلك الشاب؛ يبدو أميرًا من مظهره وطريقة كلامه ولباقته وتعامله معها، لا أحد يفهم ما يدورُ في المكان، غموض، صمت، حراسة هنا وهناك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بعد أيّام معدودات من مكوث لؤلؤة وحيدةً في السجنِ، حضر إليها الرجل الضخم، ولكنْ هذه المرّة من دونِ امرأة، أمرها بالوقوف.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة تنظرُ إليه في خوف: إلى أين؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الرّجل: لا تسألي؛ لأنّه ليس من شأنكِ!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة بعدَما وقفت: هل ستأخذني إلى أُختَيَّ؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سكتَ الرّجلُ وجرّ لؤلؤة جرًّا أمامَه؛ أخذها في ممرّات طويلة لا نهاية لها، ثمّ وقفَ أمام باب حديدي كبير وفتحَه، ودفعَها بقوّة إلى الداخل.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فوجئت لؤلؤة بالمنظر الَّذي أمامها؛ نساء كثيرات هنا وهناك يجلسنَ في كُلِّ زاوية من الغرفة الواسعة، توجّهنَ بأنظارهنّ إليها؛ فقامَت إحداهنّ إليها تسألها:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هَل أنتِ جديدة هنا؟! من أين أتيتِ؟!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم تردَّ عليها، واكتفَت بالصّمتِ، وانزوَت في الجانب الغربي من الغرفة الكبيرة، أخذَتِ الدموع مجراها على خدّيها النّاعمين، وتزاحمَت كُلُّ الأفكار في رأسها، ثمّ وقفت وحدَّثت نفسها:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("رُبّما أُختايَ هنا!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أخذَت تهرول في المكان وعيناها على جميع الشابات اللواتي ينتشرنَ في كلّ مكان، ثمّ تسألهنَّ:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هل رأيتنَّ أُختَيَّ؟! هل صوفيا هنا؟! هل جمانة هنا؟!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم تُجِبْها أيٌّ منهنَّ، بل قهقهت إحداهنَّ وهي ترمقُها بنظرات غريبة، ثمّ أمسكَت بها أخرى متوسطة العمر؛ فطلبَت منها أنْ تهدأ، وقالت لها: تعالي معي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جلست لؤلؤة مع الفتاة في إحدى الزوايا، وسألتها عن اسمِها، فأجابتها، وأخبرتها بقصّتها باختصار، وبأنّ أُختَيْها اختفَتا، وأنّها لا تعرف مكانهما، كما لا تعرف مصير أبوَيها، فطمأنَتْها الفتاةُ بأنّ كلَّ شيء سيكون على ما يرام، المهم أنْ تهدأَ وألّا تحاول الهرب:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة: أين نحن؟! ما هذا المكان؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الفتاة: نحن في قلعة الأمير باهِر وقصره، نحن جواريه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة شهقت مدهوشةً: جوارٍ؟!")])]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("****")])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("غادرت القافلة المكانَ، ومَنْ فيها لا يعلمون إلى أين تتَّجهُ، سارت أيّامًا معدوداتٍ ورُبّما أقل؛ فالخوفُ أفقدَ جمانة التركيز في الوقت، تقف أحيانًا القافلة لإعداد الطعام، ثمّ تُكمل المسير، والعجوز الَّتي تجلس بجانبها قد لاحظت حزنها، وأنّ رأسَها دائمًا بين كفّيها ودموعها تنهمر بين فينة وأخرى فقالَت لها:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ما بكِ يا بنتي؟! لماذا كلّ هذا الحزن؟!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم تُجِبها جمانة، فكرّرت العجوز السؤالَ وهي تضع يديها بحنانٍ على كتفي جمانة؛ رفعَت عينيها إليها في خوف وبؤس، وقالت:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جمانة: ما الفائدة إنْ عرفتِ قصّتي؟! ماذا تستطيعين أنْ تفعلي لي؟ أنتِ هنا أسيرة مثلي!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("العجوز: أُخفّف عنكِ حزنكِ، ورُبّما أستطيع أنْ أُساعدكِ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جمانة: هل حقًا تودّين مُساعدتي؟! سأُخبركِ بقصتي، وأرجو أنْ تساعديني، ولكنْ أخبريني: لماذا نحن في هذه القافلة؟! وإلى أين نتجه؟! ومَنْ هؤلاء النسوة الكثيرات؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("العجوز: هذه قافلة الجواري المتّجهة إلى بلاد الظلام.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جمانة، وهي تبكي: جوارٍ؟! أنا لست جارية، اللصوص أخذوني من أُمّي وأبي، لا أُريد أنْ أبقى هنا، أنا لست جارية!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("العجوز: اهدئي يا بنتي! أُصدِّقُكِ، ولكنْ باعوكِ وانتهى الأمر.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جمانة: مَنْ الَّذي باعني؟! لا أعرف أحدًا هنا!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("العجوز: لا أعرفُ مَنْ باعَكِ، رُبّما اللصوص، ولكنْ قد دفعْنا ثمنَكِ لنأخذكِ معنا، اهدئي وأخبريني بقصَّتكِ، ومِن أينَ أتيتِ؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("روَت جمانة للعجوز قصّتها مع أبوَيها وأُختَيْها؛ فحزنت لحالهم، وطمأَنتها بأنّ لديها إحساسًا بأنّها ستلتقيهم عاجلًا أو آجلًا، والمهم أنْ تصبرَ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وصلَت القافلة إلى قصر كبير، فتحَ الحرس البابَ الكبير، ونزل كلّ مَنْ في القافلة من رجال ونساء، أمرهم أحد الحرس بأنْ يتبعوا المرأةَ الواقفة في وسط الحديقة، فتبعوها حتَّى أدخلتهم من الباب الخلفي للقصر؛ باب الخدم، وإذا به قصر كبير واسع وبه الكثير من الجواري والخدم.")])]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("****")])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بعد شهرين والحال على ما هو عليه، بدأَت صوفيا تشعرُ بالغثيان المتكرِّر، وطلبت نائلة؛ المساعدة الشخصية لها، طبيبَ الأمير؛ ففحصها، ثمّ همسَ في أُذن نائلة بكلمات، وخرجَ؛ فتهلَّل وجهُها:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا: ماذا قال لكِ؟! لماذا لم يخبرني بما أُعاني؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة: إذا كان كلام الطبيب صحيحًا؛ فستكونين أسعد امرأة في هذا القصر.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا: لا أفهمُكِ! تكلّمي بوضوح: ماذا قال لكِ؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة: قالَ إنَّكِ حامل!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا، تصرخُ: ماذا؟! حامل!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أخذت صوفيا تبكي وتبكي وتضرب وجهها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة: اصمتي، سأذهبُ لأُخبرَ مولاي الأمير فأحصل منه على هدية ثمينة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا: هل الأمير سيفرح بهذا الخبر، أم أنّه سيقتلني؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة: سيفرح كثيرًا أيَّتُها المجنونة، للأمير قصّة طويلة سأحكيها لكِ فيما بعد، دعيني أذهب.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا: تعالي، أرجوكِ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أخذت نائلة تهرول في الممرّات الطويلة حتَّى وصلت إلى باب جناح الأمير؛ فطرقَتِ البابَ بخوفٍ، مرّةً، ومرّتين – وهي فقط المخوّلة بطرق الباب على الأمير ودخول جناحه – ثمّ فُتح:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة: مولاي، لديّ خبر مهم جدًّا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأمير، مِن خلف الباب: تكلّمي بسُرعة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة، فَرحة: صوفيا حامل!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأمير: ماذا؟! ماذا قُلتِ؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة: صوفيا حامل.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأمير: كيفَ عرفْتِ؟! مَنْ قال لكِ هذا؟! هل هو الطبيب؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة: نعم؛ إنّه طبيبكَ الخاص يا مولاي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أقفلَ الأمير الباب في وجه نائلة، لكنّها ظلَّت واقفةً، ثمَّ فتحَه؛ فرمى عليها صرّةً كبيرة فيها مبلغ كبير من المال.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ما لبثت نائلة أنْ عادَت إلى صوفيا تُخبرها بفرح الأمير؛ فتساءَلت:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ما الحكاية؟! ولمَ أنتِ فرحة إلى هذه الدرجة؟! أكاد أموتُ من الخوف؛ قد يقطع رأسي!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة: الحكاية يا صوفيا، إنَّ الأميرَ قد تزوَّجَ مرّات عدّة، وأيضًا لديه جوارٍ كُثر، ولكنْ لم يُوهَب الولد حتَّى اليوم، كما أنّه وحيدٌ بعد موت أبوَيه، وليس لديه إخوة، وهنا – في بلادنا – لا يُنصّب الأمير ملكًا إلّا إذا كان لديه ابن، وحينما يبلغ وليُّ العهد السنة السادسة عشرة من عُمره، يُعلَن أنّ الأمير أصبح ملك البلاد، كم أنتِ محظوظة لو كان الجنين ذكرًا، فسيكون ذلك كرامة من السماء انفتحَت لكِ بها الخيرات من كلّ مكان، لن تبقي جاريةً؛ سيتزوَّجكِ الأمير، إنّه وعدَ بذلك مَنْ ستُنجب له ولي العهد، ستكونين زوجته الرسميَّة، ثمّ ستُصبحين أُمًّا لولي العهد، يا لكِ من محظوظة!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جلَست صوفيا على طرف السرير وتكاد لا تصدِّقُ ما سمعت أُذناها، هل ما تسمعه صحيح؟! كان أقصى طموحاتها أنْ تخرجَ من قريتها، وأنْ تتعرّفَ إلى العالَم الخارجي، صحيح أنّها طمعَت في حياة أجمل، ولكنْ لم تتوقَّعْ أنْ تصلَ إلى هنا! رُبّما القدر سيعطيها أكثر ممّا ترجو، ولكنّها رغبتَ لو كان ذلك بمعيّة عائلتها.")])]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("****")])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كانت لؤلؤة تجلسُ بين الجواري وهي لا تعلمُ بأنَّ أمتارًا قليلةً تفصلها عن صوفيا؛ إنَّها في الطبقة السُّفلى من القلعة، بينما صوفيا في الطبقة العُليا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بدأت لؤلؤة تنسجمُ مع الجواري – لا حلَّ آخر لديها – تتحدّث معهنّ، وتعمل ما يُطلَب منها، حياتها مُملّة وكما هي، ولكنْ ما هوَّنَ عليها أنْها تصادقَت مع جارية شعرت بأنَّها قريبةٌ منها؛ وراحت تحكي لها همومها، وتسمع منها النصائح، كما تسمع منها بعض أخبار القلعة؛ فعرفَت أنَّ لهذه البلاد ولهذه القلعة أميرًا يُدعى باهر.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لفت انتباهَ لؤلؤة جاريةٌ اسمها حسنة؛ تنظرُ إليها بخُبث وتهمس لجارية أخرى في جوارها؛ وحسنة معروفة بالغيرة الشديدة وكيدها لباقي الجواري.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تكرَّرَ فِعل حسنة، حتَّى انزعجت منها لؤلؤة؛ فوقفَت ذات يوم تسألُها:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ماذا بكِ؟! لماذا تنظرين إليّ وتهمسين؟! هل تعرفينني من قبل؟!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وقفَت حسنة وأتت إليها ودفعَتها بقوّةٍ، وطلبَت منها أنْ تحادثَها بأدب؛ فهي ليست جارية عادية هنا!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة، بعجب: مَنْ تكونين؟! أنتِ مجرّد جارية.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حسنة: أنا المحظيَّة لدى الأمير باهر، ويجب أنْ تُحادثيني بأدب، لا تظنين أنّكِ ستحُلين مكاني؛ لأنّكِ جديدة وجميلة، لن يحدث هذا أبدًا ما دمتُ هنا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أمسكَت إحدى الجواري بيد لؤلؤة، وأخذَتْها معها، وهمسَت في أُذنَيها:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هيَّا معي؛ سأُخبركِ بكُلِّ شيء.")])])]), _vm._v(" "), _c('li')]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("****")])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جمانة تخرجُ إلى حديقة القصر مع العجوز، ولم تعلم بأنَّ هناك أميرًا لهذا القصر ويُدعى أكنان إلّا حينَما كانَت تقطف أزهارًا ذات يوم؛ إذ سمعَت صوتًا من خلفها:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ماذا تفعلين؟!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قفزَت من مكانها؛ فالصوت غريبٌ عليها؛ لم تسمعه من قبل، وهي تضع يدها على فمها كي لا يعلو صوتها؛ فشاهدَت شابًّا وسيمًا يقفُ أمامها؛ أصابها الشرودُ وهي تتفحّص ملامح وجهه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأمير أكنان: مَنْ أنتِ؟! لماذا أنتِ هنا؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جمانة: أنا جُـ.. جُـ.. جمانة!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأمير أكنان: لماذا أنتِ هنا؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جمانة: لا أعلم!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأمير أكنان: كيف لا تعلمين؟! كيف أتيتِ إلى القصر؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جمانة: مع القافلة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأمير أكنان: آه! قافلة الجواري القادمة من البلاد المجاورة!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جمانة: نعم؛ ولكنّي لستُ جارية!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأمير أكنان: لستِ جارية! إذًا مَنْ أنتِ؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("خافت جمانة من الأمير أكنان، وأخذَت تجري إلى المدخَل الخلفي للقصر وهو يُتابعُها بعينيه.")])]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("****")])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تتوالى الأشهر والأيام تمضي وبطنُ صوفيا ينتفخ، وانتشرَ الخبر في القصر وفي البلاد كاملة، كما انتشرَ بين الجواري:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هَل تعلمون بأنّ الجارية الجديدة حامل؟! قد يتزوّجها الأمير لتصير زوجته!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم تُعِر لؤلؤة الخبر أهميةً؛ لأنّه لم يخطر في بالها أنْ تكون أُختها صوفيا هي زوجة الأمير في المستقبل.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ما إنْ سمعَت حسنة بالخبر حتَّى كادَت أن تموتَ من الغيرة، وأخذت تصرخُ وتضرب وجهها:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مَنْ هذهِ الجارية الَّتي حملت من الأمير؟! الأميرُ كان يحبُّني، كنت سأُصبح زوجته! ماذا حصلَ؟! ماذا حصل؟!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ثمّ أخذت تهذي وتتوعَّد بأنَّها ستعود المحظيَّة لدى الأمير.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم تُعِر الجاريات حسنة أيَّ اهتمام.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("توطّدت علاقة صوفيا بـنائلة؛ مساعدتها الشخصية، وبعد حملها تغيّرت معاملتها لها، وهي تكاد لا تخرج من الغرفة، وأوامرها مجابة؛ فقط تشير إلى ما تريد؛ إنّها أوامر الأمير.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مرّت الأشهر سريعةً، وها قد حان وقت الولادة، وبدأت آلام المخاض، وصوفيا تصرخ، والكلُّ يجري هنا وهناك في توتُّر يعمّ المكان؛ حانت ولادة الأمير الصّغير، حضر الطبيب على عجل، وبدأت نائلة تساعدهُ، فتحضر له الماء الساخن – كما جرت العادة – وأحيانًا تجلس عند صوفيا وتمسح على رأسها، وتجفّف العرق عن جبهتها، وتواسيها، وتطلب منها الصبر.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وصل الخبر إلى الأمير باهر؛ فأصابه التوتُّر والخوف والقلق، وأخذ يمشي في جناحه الخاص؛ لا يستطيع الجلوسَ؛ ينتظر الخبر بفارغ الصبر.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بعد ساعات معدودات، بدأَ صُراخ المولود يعلو في المكان، أمَّا الأمير باهر فلا يزال في جناحه الخاص ينتظرُ الخبرَ، أراد أنْ يأتي إلى غرفة صوفيا، ولكنْ ما لبث أنْ عاد أدراجه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جاءَتِ البُشرى بفرحٍ وسرور على لسان الطّبيب:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إنّه ذكر!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تعالَى صوت نائلة، وجرَت نحو الباب لتُبلغَ الأمير باهرًا بالخبر السعيد الَّذي سيعمّ أنحاءَ البلاد، والَّذي سيضيف بهجةً وفرحًا في أنحاء القصر بعدما خيّم عليه الهدوء سنواتٍ طويلة، ثمّ جرت في ممرّات القلعة الكبيرة وهي تضحكُ فرحًا وتفكّر:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مَاذا سيعطيني الأميرُ باهر هذه المرّة؟! إنّ هذهِ فرحة عمره الَّتي ينتظرها منذ سنين عدّة!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة، بعدَما طرقت الباب بقوّة: سيدي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("خرج الأمير باهر على عجلٍ وهو يصرخ فيها:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ماذا؟! أخبريني؟!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة: وصلَ وليُّ العهدِ! مُبارك يا مولاي!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأميرُ باهر: ماذا تقولين؟! أحقًّا؟! أحقًّا ما تقولين؟! هل أنتِ متأكّدة؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة: نعم يا مولاي؛ لقد رأيتُه بعينيّ هاتين.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأمير باهِر: سأُعطيكِ وزنكِ ذهبًا لهذا الخبر.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة: سآتي بهِ حالًا إليك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("هرولَت نائلة نحو غرفة صوفيا؛ فأخذَتِ الوليدَ من يد الطّبيبِ وذهبَت به إلى الأمير باهر، الَّذي ما إنْ رآه حتَّى اغرورقَت عيناه بالدموع.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأمير باهر: كم دعَا أبي أنْ يراكَ قبل أنْ يموتَ!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أخذَه بين يديه وقبَّلهُ وضمّهُ إلى صدره:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سأُسمّيه \"أمير\".")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة: اسمٌ مُبارك يا مولاي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("انتشر الخبرُ في القلعة الكبيرة، كما انتشرَ في جميع أنحاء البلاد؛ فعمّتِ الفرحة جميع النَّاس، وصُنع الطعام، ووُزّع في كلّ مكان، احتفالًا بولادة وليِّ العهد.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أُعلنَ أنّ القصرَ يبحثُ عن مُرضعات ومُربّيات للأمير الصَّغير بشروط معينة؛ فتوافدَت الكثيراتُ منهنَّ، واختيرت الأفضل، كما أعلنَت الاحتفالات أسبوعًا كاملًا بهذه المناسبة السعيدة.")])]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("****")])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نادى الأمير أكنان العجوز؛ فهي قريبة منه جدًّا، وسألَها عن الفتاة الغريبة الَّتي يراها دائمًا شاردةً في حديقة القصر؛ فأخبرَته بقصّتها:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إنَّها ليست جاريةً، ولكنَّها بِيعت مع الجواري إلى أنْ وصلَت إلى هنا.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لَم يستطِع الأمير أكنان إخفاء إعجابه بهذه الفتاة؛ لأنَّ جمالَها أخّاذ، إنَّ صوفيا تفوقها جمالًا، ولكنْ هي أيضًا جميلة، وليس الجمال وحدهُ ما لفتَ نظره إليها؛ فهي مُتحدِّثة لبقة، وروحها جميلة، ولديها جاذبية شدّته إليها؛ فرُبّما نشأتها مع أبوَين اهتمّا بها جعلَت منها فتاة متزنة، ولولا ما حدث لها، لكانت تنعم بحياة عائلية سعيدة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("دائمًا ما كان الأمير أكنان يقفُ في شرفة مطلّة على الجانب الأمامي للحديقة يُراقِب كلّ شيء، ودائمًا ما كان يلاحظ جمانة، مع الجواري تارةً، ومع العجوز تارةً أخرى.")])]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("****")])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة لا تفارقُها ضحكاتُ أُختَيْها في حياتهما السابقة، وتتخيَّلُ ما يكون عليه حالهما اليوم، رُبّما أنّهما تتعرّضان لألوان من العذاب، تفكِّر كثيرًا في الهرب من هنا، يجب أنْ تبحثَ عن أبوَيها وعن أُختَيْها، صارحَت صديقتها بذلك؛ فنهرَتها في بداية الأمر، ولكنْ مع إصرارها قَبِلَت مساعدتها؛ فكّرتا في خطّة، وخطرَت لصديقتها فكرة:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كُلّ يوم خميس يأتي بديع إلى القلعة من الباب الخلفي؛ يأتي بما يطلبه طبّاخ الأمير، ما رأيكِ أنْ أُخبره عنكِ؟")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة: مَنْ هذا بديع؟! هل تثقين به؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الصّديقة: إنّه جشعٌ؛ سيطلبُ مُقابلًا لهذه الخدمة، ولكنْ سنسألُه أولًا ونرى، هو الوحيد الَّذي أعرفُه يدخل ويخرج من القلعة دائمًا، حسنًا؛ سأنتظرهُ حتَّى يوم الخميس المقبل لأسأله.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("شعرت لؤلؤة بأنّ الأسبوع طويلٌ جدًّا، تريد أنْ تخرج من هنا بأسرع وقت.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أتى بديع في يوم الخميس، ذهبَت إليه الصديقة لتحدّثه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("انتظرَت لؤلؤة صديقتها بفارغ الصبر لتخبرها برأيه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بعدَما استطاعت الصديقة مُحادثته، لمعَت ضحكة خبيثة في وجهه، وقال:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ما المقابل لهذا العمل الصعب؟ يمكن أنْ يَكشفَ أمري أحدٌ ويذهب رأسي؛ إنّها مخاطرة كبيرة!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الصّديقة: ماذا تريدُ وأنا سأُخبرها؟ هي مُستعدة لأيِّ شيء؛ فهي لا تستطيع إكمال حياتها هنا!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بديع: كما تعلمين؛ فإنّني تزوّجتُ مرّتين وطلّقتُ، أنا في حاجة إلى زوجة تخدمني؛ هل تقبل الزواج بي؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الصّديقة، في همس: كانَ الله تعالى في عونها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بديع: ماذا تقولين؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الصّديقة: لا شيء، لا شيء! حسنًا؛ سأُخبرها، وإنْ وافقت؛ فالخميس المقبل ستكون معك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ذهبَت الصديقة إلى لؤلؤة لتخبرها بطلب بديع الغريب؛ ففوجِئَت في بداية الأمر، ثمّ ما لبثَت أنْ وافقت، نصحَتها صديقتُها بالتروي والتفكير جيدًا؛ فهذا الرجل لا يُطاق؛ فهو بخيل وجشعٌ، لم تتحمّله زوجتان من قبل!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة: لا يهمّني ما دامت هذه الطريقة الوحيدة لخروجي من هنا، أنا هنا كأنّي في سجن، الهدوء والصمتُ يعمّان المكان، باستثناء أصواتكنَّ الَّتي نادرًا ما تعلو، وغير ذلك تفكيري طوال الوقت في أُمّي وأبي وأُختَيَّ، سأكون مستعدة الخميس المقبل، ولكنْ عِديني ألّا تخبري أحدًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الصّديقة: لن أُخبر أحدًا، ولكنْ سأشتاق إليكِ كثيرًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أخذَت الصديقة لؤلؤةَ في حضنها، وتعانقتا عناقَ الفراق.")])]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("****")])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حظيَت صوفيا بمكانةٍ عالية بعد إنجابها، وعُقِد قران الأمير باهر عليها وهي تكادُ لا تُصدِّق، وعلى الرغم من بقائِه مُنعزلًا في جناحه، فإنّه يخرجُ منهُ مرّات معدودات ليطمئنَّ على أنَّ كُلَّ شيء على ما يرام، ولكنْ – على أي حال – أصبحت زوجة أمير بلاد الشمس الساطعة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بدا الأمير أكنان غامضًا؛ فهو دائم الصمت، غير أنَّ المرَّة الوحيدة الَّتي تحدَّث فيها إلى جمانة كانت في ذلك اليوم.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جلست جمانة إلى العجوز تسألها عنه:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لماذا هو وحيد؟!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قالتِ العجوز:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كانَ طفلًا مُدلّلًا لدى أبوَيه وأُخته الوحيدة الَّتي تكبره بسنوات معدودات، ولكنْ حدث ذات ليلة ما لم يكن في الحسبانِ؛ إذ شنَّت جماعاتٌ غارة عليهم، دخلوا القصر فقتلوا مَنْ قتلوا من الجواري، كما قتلوا الملك وزوجته، ولحقَت بهما ابنتهما فأسروها، ولا نعلمُ بمكانها حتَّى هذه السَّاعة، ولأنّني كنتُ هنا، أخذتُ الأميرَ الصّغير أكنان معي وخبَّأتهُ في قبو سريٍّ لا يعرف مكانه أحد، ومكثتُ معه فيه أسبوعًا كاملًا لا يعلم بنا أحد، ولا يعلم بخوفِنا وفزعنا إلّا الله تعالى، وكان في هذا القبو يُخزَّن بعض الطعام؛ فاستطعنا أنْ نأكلَ منه، وحينما هدأتِ الغارةُ وسكن المكان، خرجتُ وحدي لشدَّة خوفي على الأمير أستطلعُ الأمر؛ فكانت الجُثث مُلقاة في كلّ مكان، ومنذ ذلك الوقت، يعيش الأمير وحده، ولا يثق بأحد سواي، وأنا بين فينة وأخرى أذهبُ لشراء بعض الجواري لأملأ هذا القصر ثمّ أعود، ولطالما حاولتُ أنْ أُقرِّبَ منهُ إحداهنَّ، ولكنْ من دون جدوى، ولكنّه سألني عنكِ – أوّل مرّة يسألني عن بنت – واطمأنَّ أكثر حينما علمَ بأنّكِ لستِ جارية، وبأنَّكِ خُطفتِ من أبوَيكِ.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جمانة: أحقًّا سألكِ عنّي؟! يبدو لطيفًا جدًّا!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("العجوز: أوّل مرّة يسألُني عن إحداهنَّ هنا، دائمًا هو في حذر من جميع النَّاس باستثنائي أنا؛ إنّه يحبّني كثيرًا، ويثقُ بيّ، وأنا أحببتكِ كثيرًا؛ إنَّكِ مختلفة، وسأجعله يثقُ بكِ.")])]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("****")])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كانت جمانة تفكِّر في الهرب بين فينة وأخرى، ولكنْ لا تعلمُ كيف! حاولَت التعرُّفَ إلى مداخل القصر ومخارجه لكي تهرب إنْ سنحت لها الفرصة، ولكنّها آثرَت التمهُّلَ حتَّى لا يحسَّ بها أحد، كما أخفَت ذلك عن العجوز حتَّى لا تخبر الأمير أكنان.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أتى يوم الخميس على عجل، واستعدَّت لؤلؤة للهرب من هذا المكان الَّذي هو بمقام سجن لها، وهي لا تعلمُ بأنَّ صوفيا على بُعد أمتار قليلة عنها، ستفرُّ هاربةً، ولن يقف أمام حلمها أحد، استعجلَتْها صديقتها، وبدت حركاتهما غريبة، ولكنْ لا يأبه بهما أحد؛ هنا كلّ مُنشغل بنفسه إلّا حسنة؛ فهي دائمة النظر إليها؛ تغارُ منها، وتخاف أنْ يأتي يوم وتُؤخَذ إلى الأمير باهر، تتبعُها بنظرها أينما ذهبت، وتحاول لؤلؤة التهرُّب منها ومن نظراتها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كانت عينا بديع على الباب وهو يُنزل الحاجات إلى المطبخ ويساعده بعض الخدم؛ شكرهم، وأخبرهم بأنَّهُ يستطيع أنْ يُنزلَ كلَّ شيء وحده؛ إنّه يريدُ أنْ يخلو المكان حتَّى يسهلَ عليه إخراج لؤلؤة منه بأمان، وما هي إلّا لحظات حتَّى حضرتَا؛ فدُهِشَ لجمالها؛ لم يتوقَّع ما رأت عيناه؛ فتحمَّس أكثر وأسرع في إنزال كلّ شيء.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في تلك الأثناء، تسلَّلت لؤلؤة وصديقتُها باتجاه عربة الطّعام، دخلتها لؤلؤة بأمان، بينما استدارَت صديقتُها راجعةً بعدما اطمأنّت عليها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أسرع بديع في سَوق الخيل، واستمرَّ في طريقه خارجًا من القلعة وقلبهُ يدقُّ خوفًا وفرحًا، ولم يتوقَّف إلّا أمام بيتهِ الصَّغير المتواضع، نزل مسرعًا، وتلفَّت يمنةً ويسرةً، ثمّ أنزلَ لؤلؤة، وطلبَ منها دخول بيته، ظلَّت واقفة وهي تُغطِّي وجهها، ورفضَت الدخول معه إلّا بعد أنْ يتزوّجها، طمأنَها بأنَّهُ سيتزوّجها، ولكنْ الآن عليها بالدخول حتَّى لا يلاحظها أحد، فدخلت في خوفٍ وتردُّد شديدَين، وقفت أمام الباب من الدَّاخل وهو يطلب منها الدخول، وأنّه سيتركها ترتاح، وغدًا سيُحضر شاهدين ليتزوّجها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("اطمأنّت لؤلؤة قليلًا إلى حديث بديع؛ بدا لطيفًا معها، دخلَت غرفةً صغيرة وأقفلَت الباب، وما لبثَ أنْ طرقه وأعطاها بعض الطعام، نامَت في هدوء على الرغم من خوفها الشديد من هذا الرجل الغريب، ولكنْ على كُلِّ حال هي ضائعة: لا عائلة لها ولا أهل يخافون عليها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في الصّباح، وفى بديع بوعده لـلؤلؤة؛ فأحضرَ شاهدين وتزوّجَها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم يلحظ أحد اختفاء لؤلؤة في أوّل الأمر إلّا حسنة؛ فحينما عادَت الصديقةُ وحدها سألَتها عنها، ولكنّها لم تُجِبْها، بل ظلّت صامتة، وحسنة تُكرِّر عليها السؤال؛ لقد شكَّت في أنْ تكون أُخِذَت إلى الأمير باهر؛ فطمأَنتها الصديقة بأنّها بعيدة جدًّا عنه، بيدَ أنَّها لم يهنأ لها بال، وأخذَت تمشي في ممرّات القصر وتبحث عنها في كُلّ مكان، ولكنْ من دون جدوى؛ فرأَتها نائلة وأمسكَت بها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة: ماذا تفعلين هنا؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حسنة: لا شيء، اتركيني؛ ماذا تريدين مني؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة: اذهبي من هنا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حسنة: لن أذهبَ؛ أرغبُ في أنْ أرى الأمير باهرًا، أُريد أنْ أُخبره بشيء.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة: لن تري الأمير، ولا تطلبي هذا الشيء مرّة أخرى، ولا أُريد أن أراكِ في هذا المكان، ثمّ دفعتها بقوّة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حسنة، تنظر إليها بنظراتِ غضب وتوعُّد:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إذًا أُريدُ أنْ أرى مَنْ تدّعي أنّها زوجة الأمير!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة: مَنْ تدّعي! إنّكِ مسكينة؛ ما زلتِ تعيشين في الماضي، اذهبي إلى مكانكِ الَّذي جئتِ منهُ وإلّا ناديتُ الحرسَ ليحملوكِ من هنا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عادت حسنة أدراجها وهي تغلي غضبًا وحنقًا، وتتوعَّدُ بأنّها ستعود إلى هذا المكان مرّة أخرى.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("اعتادَ الأمير أكنان الجلوس في الشرفة، ودائمًا ما تقع عيناه على جمانة تمشي في الحديقة؛ إمّا وحدها، وإمّا مع العجوز، رفعَت عينيها إليه هذه المرّة وابتسمت برقَّة، فنزل إليها في ذلك اليوم وتحدَّثَ إليها، أعلمَتْه بأنّ العجوز أخبرتها بأنَّه لا يثق بأحد؛ فأجابَها بالموافقة، ظلّا يتحادثان طويلًا، وبدا كُلٌّ منهما يشعر بالارتياح إلى الآخر، وتهامسَت بعض الجواري عن علاقتهما، ولكنَّها لم تُعِرهنّ اهتمامًا.")])]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("****")])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("انتشر خبرُ وليُّ العهدِ، وسمعَت به لؤلؤة وجميع مَنْ في البلاد بعدَ أشهر معدودات. ظهرَ حملُ صوفيا الثّاني؛ فكاد الأميرُ باهر يطير فرحًا، وطلب منها الجلوس والتحدُّث إليه، أرادَ أنْ يتعرَّف إليها أكثر، أخبرَتْه بقصّتها كاملةً، وأنَّها كانت ترجو هجرة قريتهم الصغيرة، وأنَّها هي مَنْ ألحّت على أُمّها، الَّتي أقنعَت أباها بالرّحيل، وأنّهم في طريقهم هجم عليهم قُطّاع الطّرق؛ فخطفوها وضربوها وباعوها مع أُختَيْها إلى أنْ وصلت إلى هذه القلعة، وأنّ أبوَيها ما زالا مفقودَين، وأنّها تفكِّر فيهما ليلًا ونهارًا، وطلبَت منه مساعدتها في البحث عنهما؛ فوعدَها بالبحث عنهما في كُلِّ مكان؛ اطمأنّ قلبها قليلًا؛ فهو أمير وصاحِب سلطة، ومن المؤكَّدِ أنّهُ يستطيع أنْ يجدهما.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ما كان الأمير باهر يطلبُ ذلك سابقًا، كان فقط يُريد أولادًا، أمّا اليوم؛ فأحسَّ بأنّه بدأ يُحبُّ هذه المرأة، هل بسبب إنجابها، أم لسبب آخر لا يعلمه؟! كانت بالنسبة إليه مجرّد جارية كباقي الجواري، ولكنَّها اليوم أُمٌّ لابنه، وها هي حامل ثانيةً، شيء لم يكُن في الحسبان، تزوَّج عدَّة أميراتٍ ولم ينجبن له، كما أنَّهُ لم يتعلَّق بهنَّ، فطلقهنَّ وعاش وحيدًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كانت حسنة أكثر الجواري قُربًا من الأمير باهر، ولكنْ لشدَّة غيرتها من كُلِّ شيء ومن باقي الجواري أصبحَ لا يُطيقها، فأبعدَها عنه، المهم أنَّ حياتَه تغيَّرت كثيرًا؛ فأصبحَ يخرج من جناحه ويطمئنُّ بأنَّ كلَّ شيء على ما يرام، كانَ يعتمدُ كليًّا على وزيره إيهاب، ولكنَّ الأمر اختلف اليوم؛ حينَما يكبر ابنه ويُنصّبه وليًّا للعهدِ، سيصبح لقبه الملك بدلًا من الأمير – هكذا هي عادتهم في هذه البلاد – وهو ينتظر ذلك بفارغ الصبر، ولكنْ عليه اليوم الاقتراب أكثر من شعبه والاستماع إليهم؛ فأخبرَ وزيره بأنْ يحدِّدَ له يومًا في كلِّ شهر ليجلس في مجلسه ويلتقي النَّاس.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بعدَ مضي أشهر معدوداتٍ، أنجبَت صوفيا الأمير الثَّاني؛ فرحَ به أبوه الأمير باهر فرحًا شديدًا، وسمّاه \"إمهال\"، لقد انتظرَ عشرين سنة ليُصبحَ أبًا، يا لشدة فرحه اليوم! كان يرجو الله تعالى ابنًا واحدًا فأعطاه اثنين!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حتّى اليوم، لم يُعلِن الأمير باهِر اسم زوجته صوفيا لشعبه، إلّا ما يتسرَّب من أخبار عن طريق خدم القصر، كما لم يُنصّبها أميرةً، رُبّما لشيء يُخفيه في نفسه، رُبّما لأنّها غريبة، هذا لم يعنِ أنّه لا يحبّها ولا يُقدِّرها، بل استطاعَت أنْ تأسرَ قلبهُ بروحها المرحة؛ فهي جميلة من الدَّاخل ومن الخارج، كما أنّها لبقة في كلامها وناعمة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تجمهرَ الشعب أمام القلعة بعد إعلان الخبر، وخرج إليهم الأمير باهر يلوّح لهم بيدَيه من أمام باب القلعة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تزيّنت المدينة مرّة أخرى، وصُنع الطعام بهذه المناسبة السعيدة، وتقدّمَت الكثيراتُ من المرضعات والمربّيات يُردنَ أنْ يحظينَ بإرضاع الأمير الصغير وتربيته، وبعد تفحُّصٍ شديد، اختيرَت ثلاث منهنّ لهذه المهمّة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("زاد اهتمام الأمير باهر بابنهِ الأمير الصغير أمير، وقال:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سأُربّيه كما تربيت أنا؛ سيركب الخيل ليصبحَ شُجاعًا.")])])]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("****")])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وبحسبِ عادة النِّساء هناك؛ فإنّهنّ يجتمعنَ إمّا صباحًا وإمّا مساءً؛ للحديث والنميمة ومعرفة أخبار بعضهنَّ بعضًا، وتعرَّفت لؤلؤة إليهنَّ، وأخبرتهنَّ بأنَّها الزَّوجة الجديدة لـبديع، وأنَّها من قرية بعيدة؛ لأنّهنَّ تساءلن أنّهنَّ لم يرينها من قبل، وتهامسنَ بأنْ يكون الله تعالى في عونها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صمتت لؤلؤة؛ فحتّى الآن لم تلحظ على بديع ما يُقال عنه، ربّما لأنَّها ما زالت زوجةً جديدة ولا يريدُ أنْ يُظهرَ وجهَه الحقيقي لها، أو لأنَّه لا يريد أنْ يخسرها كما خسر زوجتيه السابقتين، أو ربّما أحبّها.")])]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("****")])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تمضي الأيام بطيئةً عند أشخاصٍ، وسريعةً عند آخرين، وصوفيا مع تغيُّر حياتها تغيّرًا كبيرًا فإنَّها لم تُنسِها أبوَيها اللَّذين لم يفارقَا مُخيّلتها قط، كما لم تنسَ أُختَيْها، بل ظلّت تفكِّر فيهما في كُلِّ وقت، تمضي حياتها بنمط حياة القصور الَّذي لم تعرفْ عنه شيئًا قط، أصبحَت تحصل على كُلِّ ما ترجوه، ومع ذلك تشعرُ بالوحدة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عاد الرَّسول مِن دون ذكر أنَّ الأمير باهر أرسلَه بمعلومات يمكنُ أنْ تُساعد على العثور على أبوَي صوفيا؛ وقد قابلَ الوزير إيهاب، وأخبرَه بأنّ لديه أخبارًا يمكن أنْ تساعد على الوصول إليهما.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الوزير إيهاب: هاتِ ما عندكَ!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الرّسول: في بلادٍ تبعدُ عنَّا مسيرة ثلاثة أيّام، رآني رجلٌ أسألُ هنا وهناك عن رجل وامرأة كبيرين في السنِّ ضائعين؛ فأخبرني بأنَّه – منذ سنوات عدّة – أتى غريبان كبيران في السن إلى بلادهم، مُتعبَين، مَريضين، يبدو عليهما السفر، واستضافهما جارٌ لهم في غرفة صغيرة بجانب بيته، وخدمَتهما زوجته طوال تلك المدَّة، كان الرجل يخرجُ أحيانًا من البيت، ولكنَّه لم يستطِع العمل.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الوزير إيهاب: من المحتملِ أنّهما أبوَا صوفيا، سأُخبر الأمير باهرًا لنرى ماذا علينا فعله!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ذهبَ إيهاب إلى الأمير باهر، ثمّ أخبره بالأمر؛ فأمرَه بألّا يُخبرَ أحدًا وألّا يصلَ الخبر إلى صوفيا؛ حتَّى لا يتعلَّقَ قلبُها بالأمل وتُصدَم فتحزن، الأفضل إرسال أحد يتقصَّى عنهما أكثر، ويراهما بنفسهِ ليتعرَّف إليهما، ثمّ يأتي بالخبر اليقين.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في اليوم التالي، بعثَ الوزيرُ إيهاب رجلين يستطلعان الأمر، وما إنْ وصلا إلى تلك البلاد بعد سفر طويل، حتَّى سألا عن الشيخ والعجوز الغريبَين؛ فأوصلهما رجلٌ إلى الغرفة الَّتي يعيشان فيها، طرقَا الباب، وبعدَما فتحَ لهما الشيخُ سلّما عليه، ثمّ أخبراهُ بأنَّهما غريبان ويريدان ماءً، طلبَ منهما الانتظار، وذهب ليُحضرَ الماء، وظلّا واقفين في ترقُّب، يبدو المكان هادئًا كأنَّه يخلو من السُّكان، أحضرَ لهما الماء فشربا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الرّجلان: هل أنتَ من أهل هذه البلاد؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الشّيخ: إنّي غريب.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الرّجلان: من أيِّ قرية قَدِمتَ؟ هل معكَ زوجتكَ؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("استغربَ الشّيخ أسئلتهما.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الرّجلان: نبحثُ عن شخصٍ مفقود رُبّما تكون أنتَ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الشّيخ: لا أعرف أحدًا هنا إلّا هذا الرَّجل الطيب الَّذي أسكنني وزوجتي في هذه الغرفة من دون مقابل.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الرّجلان، وقد تهلَّل وجهاهما: ما اسمكَ؟! هل لديكما أولاد؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الشّيخ: أنا وزوجتي وحيدان؛ لم نُوهَب الولد.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الرّجلان، وقد تغيّرت ملامحهما: يا عمّنا، أليس لديكما بنات؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الشّيخ: لا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("خيَّم اليأس والخيبة على الرّجلين، ثمّ شكرَا الشيخَ وودّعاه، ثمّ عادَا أدراجهما إلى بلاد الشمس السَّاطعة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ما إنْ وصلَ الرّجلان حتَّى أخبرَا الوزير إيهاب بكلّ شيء؛ فقالَ: الحمد لله تعالى أنّنا لم نُخبر صوفيا بالأمر، وإلّا لأصابها الحزن، كانَ رأي الأمير باهر ألّا نُخبرها حتَّى نتأكَّد رشيدًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ذهبَ الوزير إيهاب إلى الأمير باهر؛ فأخبره بالأمر؛ فشكرَ الله تعالى أنّه لم يتسرَّع في إخبار صوفيا، وقال له:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لا تيئس؛ ابحثوا عنهما في مكان آخر، سنجدهما بإذنِ الله تعالى.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أصبحت نائلة المساعدة الشخصية لـصوفيا، كاتمةً لأسرارها، وقد تحدَّثت إليها مرارًا وتكرارًا وأخبرَتها بكُلِّ شيء، وأنَّ الأمير باهرًا عرف – في بادئ الأمر – أنّها بِيعت له مع مجموعة من الشابَّات، وقد اختيرت له كونها جميلة، لم يكُن في حسبانهِ أنَّها ستكون زوجته، ولا مقرّبة منه، وأوصى نائلة بالاهتمام بها، هذا ما أخبرَتها نائلة به.")])]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("****")])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بدأ الأمير أكنان يكسرُ وحدته بالحديث مع جمانة، وحقدُ باقي الجواري واضح عليهنَّ؛ فهنَّ لا يحببنَها ولا يفضلنَ الجلوس معها، حاولَت أغلبهنَّ التقرُّب منه، ولكنَّه كان لا يأبهُ بهنَّ، أصبح يطلب منها الجلوس إليه في جلسته الخاصَّة، ويتحدَّث إليها كثيرًا على غير عادتهِ، كما أنَّها فتحَت له قلبها وحدَّثتهُ عن خوفِها وقلقها تجاه كُلّ شيء؛ فطمأنَها بأنَّ كُلَّ شيء على ما يرام، أخبرَته برغبتها في الخروج من هذا المكان، استغرب في بادئ الأمر.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأمير أكنان: هل أنتِ غير سعيدة هنا؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جمانة: بل سعيدة، ولكنَّ سعادتي ناقصة، ليس كما كنتُ في كنف أبوَيّ؛ حيثُ دفء العائلة، لم يُنغص علينا سِوَى الفقر.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم تستطِع حسنة تحمُّلَ الأمر؛ كيف أنَّ للأمير باهر زوجة أو جارية غيرها، حاولت مرارًا وتكرارًا فعل شيء ولكنَّ خططها تفشل، لم تيئسْ؛ فدائمًا ما تتوعَّد بأنّها ستعود إلى جناحه، لم تكُن سهلة؛ كانت خبيثة وماكرة؛ خطَّطت مع جارية أخرى أنْ تُدخلَها إلى جناحه بدلًا منها؛ تزيَّنَت وتخفَّت، ثمّ ذُهب بها إلى جناحه، ما إنْ رفعَ الغطاءَ عن وجهها حتَّى أصابَته الصدمة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأمير باهر: حسنة! مَنْ أتى بكِ إلى هنا؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حسنة: اسمعني يا مولاي، فقط أردتُ أنْ أُخبركَ بشيء ولم تسمحْ لي نائلة بالدخول: ألَم أكُن المقرّبة إليك؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأمير باهر: الماضي – يا حسنة – انتهى، اذهبي من هنا؛ لا أُريد أنْ أسمعكِ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حسنة: مولاي، أُريد أنْ أُخبركَ بأنَّ زوجتكَ الجديدة ما هي إلّا جارية غريبة، وربَّما هي جاسوسة من أعدائكَ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأمير باهر: ليس لديَّ أعداء، اذهبي من هُنا حالًا قبل أنْ أُنادي الحرس.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("غادرت حسنة وهي تنظر خلفَها تريد أنْ ترى تعابير وجه الأمير باهر؛ والَّذي كان يبدو عليه الغضب.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ضرب الأمير باهر تحفة زجاجية أمامه بقوّة يديه؛ فتناثرَت إلى كلّ مكان، ثمّ فتحَ الباب:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأمير باهر، يصرخُ وينادي: نائلة! نائلة!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة، تهرولُ إليهِ: نعم يا مولاي؛ ماذا حدث؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأمير باهر: كيف دخلَت حسنة جناحنا الخاص؟! ألَم أُنبّهكِ إلى عدم السماح لها بالدّخول؟! كيف حدثَ هذا من دون علمكِ؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة، تُطأطئُ رأسها: لا أعلم يا مولاي! منعتُها مرارًا، ولكنْ سأتأكَّدُ من الأمر؛ إنّني مقصِّرة، سامحني يا مولاي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("خرجَت نائلة مسرعةً إلى جناح الجواري، وأخذَت تشدُّ حسنة من شعرها:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مَاذا فعلتِ أيّتها المجنونة؟! أتريدين أنْ تهتزَّ ثقةُ الأمير باهر بي؟! صبرتُ عليكِ كثيرًا؛ لن تبقي بعد هذا اليوم في هذا القصر.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حسنة: ماذا تقولين؟! أرجوكِ لا تفعلي ذلك!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أشارَت نائلة إلى الحرس بإخراج حسنة؛ فجرّوها إلى الخارج وهي تصرخ:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("اتركوني، اتركوني، لن يسمح الأمير باهر بهذا، لن أترككِ يا نائلة؛ سأنتقم منكِ.")])])]), _vm._v(" "), _c('li')]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("****")])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بمرور الأيّام، ظهرَت طباع بديع؛ فهو بخيلٌ في كُلِّ شيء حتَّى في المشاعر، وتوطَّدت علاقةُ لؤلؤة بجاراتها، وأصبحَت تستعير منهنَّ ما تحتاجه، ولم يستغربنَ، أخبرْنَها بأنَّه تزوَّج مرّتين ولم يدُم زواجه لبخلهِ، كما أنَّه لم يُوهَب أولادًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في إحدى المرّات، طلبَت إحدى الجاراتِ مِن لؤلؤة أنْ تحدّثهنَّ عن قصّتها، ومن أينَ أتت؛ فهي غريبة على هذه البلاد؛ فقالَت لهنَّ:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قصَّتي طويلة وشائكة!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فطلبن منها سماعها؛ فهنَّ في شوق إلى معرفتها، قصَّت عليهنَّ كُلَّ شيء، من عيشها في القرية وأحلامها الورديَّة مع أُختَيْها، حتَّى وصلت إلى هنا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تعجَّبَت الجارات كثيرًا، وفتحت إحداهنَّ فاهها وسألَتها عن اسمَي أُختَيْها؛ فأخبرَتها بأنّهما صوفيا وجمانة؛ فدُهشَت أكثر، وهمسَت لجارتها الَّتي بجنبها بحديث لم يسمَع منه شيء.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة: ماذا بكِ؟! لماذا أنتِ مدهوشة؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الجارة: إنّ زوجة الأمير باهر الجديدة اسمها صوفيا، وهي غريبة على بلادنا، ولا نعرفُ من أين أتَت! لقد أخبرَتني صديقتي الَّتي تعملُ في القصر بذلك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جارة ثانية، بقهقهة: زوجة الأمير أُختها! رُبّما أنتِ تمزحين!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الجارة الأُولى بعد صمتٍ: نعم؛ أظنُّ ذلك تشابه أسماء!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جارة ثالثة: هل تعلمنَ بأنَّها أنجبَت لهُ وليَّ العهدِ، وأصبحَت المفضَّلة لديه؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("دار كثير من الحوار بين الجارات ولؤلؤة في صمت، ولَم تكُن معهنَّ بروحها ولا بسمعها، إنَّما بجسدها فقط، نادتها إحداهنّ:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة، هل أنتِ معنا؟!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة: لا شيء، فقط أُريدُ أنْ أذهبَ إلى البيت؛ إنّي متعبة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("همَّت لؤلؤة بالرحيل؛ فخرجَت إحداهنَّ تتبعها، وفي الطَّريق، أخبرتها بأنَّ لديها صديقة مُقرَّبة كانت تعمل في القصر ولديها بعض المعلومات، وتستطيع أنْ تتأكَّدَ منها، فرحت لؤلؤة كثيرًا؛ راودَها الشكُّ في أنْ تكون زوجة الأمير باهر أُختها صوفيا، وبصيص من الأمل لاح لها؛ ولِمَ لا؟! يمكنُ أنْ يكونَ الحظ ابتسم لها أخيرًا؛ فهي ذاتُ جمال باهر، شكرَتها كثيرًا على الوقوف معها ومحاولة مساعدتها، وتواعدت معها في يوم غد.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في الصّباح الباكر، وبعد خروج بديع زوج لؤلؤة، حضرَت إليها الجارة مع صديقتها نُهيرة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة، بلهفة: هل حقًّا كنتِ تعملين في القصر؟! هل شاهدتِ زوجة الأمير باهر؟! كم عمرُها؟! كيف شكلها؟! ما أوصافها؟! ما لون عينيها؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نُهيرة: رويدًا، رويدًا؛ سأخبركِ بما أعرفُه، كنتُ أعملُ في القصر حتَّى السنة الماضية، ولم أرَ زوجةَ الأمير باهر، ولكنْ أعرف نائلة جيدًا؛ فهي المقرَّبة منها؛ سأذهبُ إليها وآتي بكُلِّ الأخبار.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("طلبَت نُهيرة من لؤلؤة أنْ تمهلها أيّامًا معدوداتٍ كي تذهبَ إلى القصر وتتأكَّد من نائلة؛ المساعدة الشخصية لزوجة الأمير باهر.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في صباح اليوم التالي، ذهبَت نُهيرة لزيارة زميلاتها هناك، وطلبَت رؤية نائلة؛ المساعدة الشخصية لـصوفيا، بعدَ السَّلام عليها، سألَتها أسئلة عدّة؛ فنهرَتها نائلة، وطلبَت منها عدم السؤال في الأمور الَّتي لا تعنيها؛ إنّها أمور القصر؛ فتوسَّلت إليها وأخبرَتها بحقيقة الأمر، وأنَّ هذه الأخبار ليست لها وإنَّما لفتاة تدَّعي أنَّها ربّما تكون أختًا لـصوفيا، فاستغربَت نائلة، وسألَتها:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أينَ هي؟!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فأخبرَتها بأنّها جارتها؛ فطلبت منها إمهالها لتسأل صوفيا وتخبرها عنها، والمساعدةُ تعلمُ أنَّ لـصوفيا أُختَيْن، وتعرف اسمَيهما؛ فـصوفيا قد أخبرَتها بكُلِّ شيء؛ فمنذُ دخولها القصر، صارَت صديقتها الوحيدة وصندوق أسرارها الوحيد.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كانَت لؤلؤة تنتظر على أحرّ من الجمر؛ تنتظرُ فرحةً تنتشلُها من هذه الحيرة؛ فرحة تنتشلها من مُرِّ الأيام وعذاب الفراق.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جاءَت الجارة ونُهيرة إلى لؤلؤة، ولكنَّ وجهَيهما لا يُبشّران بخير.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة: ماذا؟! أخبراني بأنَّها هي!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الجارة ونُهيرة: انتظري قليلًا لنتأكَّد، أمهلينا أيامًا معدوداتٍ، لم تُجبْنا نائلة، وإنَّما طلبَت منَّا الانتظار حتَّى تستأذن صوفيا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أصابَ اليأس لؤلؤة، وانطفأَت فرحتُها، وظلَّت حزينةً ووحيدةً طوال اليوم، حتَّى زوجها الجشع بديع لا يعود إلّا متأخّرًا؛ فلا يقضي معها وقتًا، ولا يتحدَّث إليها ليعرف سببَ حزنها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كانت صوفيا تجلسُ وحيدةً كعادتها، حصلَت على ما طمحت إليه وأكثر، ولكنّها لا تزالُ تحسُّ بفراغ داخلي، لا يملؤه أيُّ شيء، رُبّما هو فراغ العائلة، لا يؤنس وحدتها إلَّا جلوسها مع الأمير باهر؛ فحديثهُ عذب، ويحادثها باحترام وتقدير؛ منذُ اليوم الأول الَّذي رآها فيه، لم يشعرْها بأنَّها مُجرَّد جارية أو خادمة في قصره، حتَّى إنَّ ابنَيْها لا تراهما طوال اليوم؛ فهما مع المرضعات والمربِّيات أغلب الوقت، هكذا هي حياة القصور، تنهمرُ دموعها كُلّما أتتها الذّكرياتُ؛ تشتاق إلى أُختَيْها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في تلك الأثناء، دخلَت نائلة؛ ففزعَت لمنظرِ وجه صوفيا الجميل وهو شاحب تغطِّيه الدموع.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة: ما سبب بكائكِ؟! هل تشتكين وجعًا؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا: نعم؛ إنَّه وجع فقْدِ عائلتي الَّذي لا يفارقني.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة، وهي تغمرُها بحنان: لقد أخبَرْتني بقصتكِ وأنا أتفهمُكِ وأتفهمُ أنَّكِ تُعانين الوحدة، وأنتِ لا تعرفين مَنْ أتى بكِ إلى هنا، ولكنْ أنا أعرفُ أنَّهم قُطَّاع الطُّرق! لقد حرموكِ عائلتكِ، ولكنْ عوَّضكِ الله تعالى فأصبحَت لديكِ عائلة أخرى جديدة؛ ألستِ فرحة بأنّكِ زوجةُ الأمير باهر وأنّ لديكِ ابنَيْن؟! ألم يعوّضاكِ عن كلّ شيء؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا، بعد صمت: ما الفائدة أنْ أعرف الآن مَنْ أتى بي إلى هنا؟! لقد باعوني مثل الجواري، ورُبَّما أُختايَ قد بيعتا في مكان آخر، الحمدُ لله تعالى أنْ أصبحَت لديَّ عائلة، ولكنْ لا يزال الحزنُ يأسرني!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ازداد انهمارُ الدموع من عينَي صوفيا؛ فوقفت نائلة وقد قرَّرت أنْ تخبرها بما حدث صباحًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة: مولاتي، هل تذكرين نُهيرة؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا: نعم؛ أذكرها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة: كانت هنا في الصباح ومعها صديقتها، وقد أخبرَتني بشيء، وأنا خائفة، وقد أخَّرتُ ذلك عنكِ لأسألكِ، والخيار لكِ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا: ما هذه الألغاز؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة: تقول نُهيرة إنَّ لها جارةً رُبّما تكون أُختكِ!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا: ماذا؟! مَنْ هي؟! ما اسمها؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة: لم أسألْهما! أخبرتُهما بأنّي سأستأذنكِ في أي معلومات.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا وقفَت غاضبةً: غدًا اذهبي إلى نُهيرة، واسأليها، ولا ترجعي إلّا ولديكِ الخبر اليقين، وإنْ استطعتِ فأحضريها إليّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("منذُ شقَّ الصّباح نورهُ، أسرعَت نائلة إلى نُهيرة، وطرقَت البابَ عليها، وجلست تُحادثها بما دار بينها وبين صوفيا، وأنَّها طلبَت إحضار الفتاة لكي تتأكَّد بنفسها؛ فأخبرَتها بأنْ تنتظرَ قليلًا كي يخرجَ بديع زوج لؤلؤة؛ فلا تريدُ رؤيته.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بعد برهة، ذهبَت نائلة ونُهيرة إلى لؤلؤة، وسلَّمت نائلة عليها، وما إنْ رأَتْها حتَّى انبهرَت بالشَّبَه الكبير بينها وبين صوفيا، وأخبرَتْها بأنَّ مولاتها تريد رؤيتها؛ ففرحَت كثيرًا، واستعدَّت لهذا اللقاء الَّذي رجَت اللهَ تعالى أنْ يكون سعيدًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("اصطحبَت نائلة لؤلؤة إلى القصر ودقَّاتُ قلبها تتسارع، ولسانُها لا يكفُّ عن الدُّعاء، وما إنْ وصلَتا حتَّى صرخَت لؤلؤة:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لقَد كنتُ أعيشُ هنا! في هذه القلعةِ! هل أُختي تعيش هنا؟! يا لي من غبية! هربتُ من هذا المكان ولم أدرِ أنَّ أُختي لا تبعدُ عنِّي سوى أمتار قليلة!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كانَت تتحدَّث وتمسح دموعها، ولاحَت لها امرأة من بعيد؛ فاستطردت: رُبّما هي أُختي، وصوفيا تلوح من بعيد ولؤلؤة تقولُ للحاجب:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أسرعْ بنا، أسرع!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وما إنْ اقتربتَا حتَّى علا صوت لؤلؤة: \"أُختي!\"، وقفزت من العربة تحتضنُها، وصوفيا لا تنطق، وإنَّما تتحدَّثُ عنها الدموعُ والآهات؛ فتعانقَتا عِناقًا قويًّا وطويلًا، كأنَّهما تريدان نسيان السنين الَّتي مضَت من عُمرَيهما وهما بعيدتان عن بعضهما بعضًا، وكُلَّما أرادَت لؤلؤة رؤية وجه صوفيا منعَها العناقُ من ذلك، لا تريدُ أنْ تتركَها، كأنَّها خائفةٌ أنْ تتركَها مرَّة أُخرى، أخيرًا تحدَّثت صوفيا:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الآن فقَط أستطيعُ أنْ أقول إنّي بخيرٍ!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("طالَ وقوفهما، وطالَ لقاؤهما، وطال وقوف نُهيرة ونائلة ودموعهما تنهمر لهذا اللقاء، وأعينهما تكادُ لا تصدّق ما ترى، نعم؛ الحياة محطّات، وها نحن نقف في محطّة اللقاء.")])]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("****")])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جمانة تعيشُ بأمانٍ مع الأمير أكنان، بدأَت تحبُّه لأنَّها أحسَّت معه بالأمان؛ فهو بالنسبة إليها كُلّ شيء، أصبح يأخذها معه لركوب الخيل، لم تركبْ خيلًا من قبل، ولكنَّه شجَّعها ودرَّبها؛ فأصبحَت تخرجُ معه في نزهة حول القصر، هو أيضًا لا يبتعدُ كثيرًا؛ فلا يزال الخوف يسيطر عليه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بعدَ انتهاء العناق الطويل، دخلَت لؤلؤة مع صوفيا القصر، وجلستا تتحادثان، من السَّاعة الَّتي سُحبَت فيها صوفيا أمام أعينهما حتَّى هذه اللحظة، ولكنْ طمأَنْتها بأنَّها في أمان، وبأنَّ الأمير باهر طيب القلب.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة: أتعنين أنّكِ لم تخرجي من هذا القصر؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا: نعم؛ لم أخرج منهُ قط.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة: يا لغبائي! لقد كنتُ أعيشُ هنا في القصر في الطبقة السُّفلى مع الجواري، ولم يخطر في بالي أنَّكِ هنا! ظننتُ أنَّهم باعوكِ!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا: هل كنتِ سعيدة في القصر، أم أنَّهُم ضايقوكِ؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة: أنا سعيدة، ولكنْ كنتُ أفتقدكُما وأفتقد أُمّي وأبي كثيرًا! هل لديكِ معلومات عن أبوَينا أو عن جمانة؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا: لا، بحثَ الأميرُ عن أبوَينا، ولكنْ لا أثر لهما! ولا أعرفُ أين جمانة؟ ما قصّتكِ؟! كيف خرجتِ من هنا؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة: هربتُ بمُساعدة صديقتي الجارية، ومع بديع الَّذي تزوَّجني ثمنًا لتهريبي من هنا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا: مَنْ بديع هذا؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة: رجل فقير وجشع.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا: لماذا بعتِ نفسكِ يا أُختي؟! لكنْ – على أيِّ حال – لو لم تخرجي من هنا لمَا استطعتِ الوصول إليّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مضى وقتٌ طويل، ثمّ تذكَّرَت لؤلؤة أنَّها تأخَّرت ولم تطبخ لزوجها، رُبَّما سيُسمعُها كلامًا جارحًا؛ فأسرعَت تُريد الذَّهابَ؛ فأمسكت بها صوفيا، وقالَت:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لا تتركيني!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة: سأعودُ إليكِ قريبًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تعانقَتا مرَّة أخرى، وافترقَتا على أملِ اللّقاء القريب.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وصلَت لؤلؤة إلى البيت، وإذا بزوجها مُتجهّم الوجه، عاقد الحاجبين، مُكتف اليدين، يتطايرُ الشَّررُ من عينيه، صرخَ بها ما إنْ رآها، وقفَت أمامَه ترتجفُ، فأمسكَ بكتفَيها يهزّها هزّة قويَّة:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أين أنتِ يا امرأة؟! ظننتُ أنَّكِ هربْتِ.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أين أهربُ وأنا غريبة هنا؟!")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("إذًا أينَ كنتِ؟! لا تحاولي الكذبَ.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لن أكذبَ، اتركني لأُخبركَ.")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أعدَّت لهُ طعامًا سريعًا، ثمّ جلسَت معهُ وهو يلتهم الطعام التهامًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بديع: تحدَّثي؛ أينَ كنتِ؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة: في القصر.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بديع: القصر! ماذا فعلتِ؟! هل جُننتِ؟! بعدما هربتِ منهُ تعودين إليه؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة: القصّة طويلة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بديع، يرمي ما بيده من طعام: أُريد أنْ أسمعها، ما هذه القصّة الطويلة؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة: وجدتُ أُختي الصُغرى.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بديع، بقهقهة: مَنْ أُختكِ؟! هل هي خادمة في القصر؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة: إنَّها زوجة الأمير باهر.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بديع، يقذف ما في فمه من طعام في وجهها: زوجة الأمير؟! من المؤكَّد أنَّكِ أُصبتِ بالحمّى!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ذهبَ يتحسَّس جبهتها؛ فأزاحَت يده بعيدًا عنها، ثمَّ قامَت من مكانها؛ فلحقها بديع:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("انتظري، أعيدي عليَّ ما قُلتِه.")])])]), _vm._v(" "), _c('li', [_c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أُختي الصغرى صوفيا هي زوجة الأمير باهر، حينما هجمَ علينا قُطَّاع الطّرقِ باعونا للأمير، وكانَت أُختي جارية لديه، وأنجبَت له ابنين؛ فتزوَّجها، وأصبحَت زوجتهُ رسميًّا.")])])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بديع: لماذا لم نسمَع باسمها من قبل؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة: لا أعرف إجابة لسؤالكَ، اتركني وشأني.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بديع: لا؛ لن أترككِ، إنْ كان كلامكِ صحيحًا فيا لي من محظوظ! زوجتي أخت زوجة الأمير! حالي سيتغيَّر! سأصبح غنيًّا! حياتي ستصبح سعيدة!")])]), _vm._v(" "), _c('br'), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("****")])]), _c('br'), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في يوم ما، جلسَت جمانة إلى بعض الجواري الجُدد؛ فأتى الأمير أكنان من بعيد؛ فذهبَت عنهنّ مُتَّجهةً إليه، أخذنَ يتهامسنَ عليها وأعينهنَّ تتبعها ويغمزنَ لبعضهنَّ بعضًا عن علاقتها به.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأمير أكنان: ماذا تفعلين؟! هل أصبحَ لديكِ صديقات هنا؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جمانة: لا أُخفي عنك سرًّا؛ لا تستهويني الجلسة معهنَّ ولا يستهويني حديثهنَّ، ولكنْ ماذا أفعل؟! أنا غريبة هنا، أردتُ تغيير حياتي؛ فتغيَّرت حياتي كاملةً وفقدتُ عائلتي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جمانة، دامعة العينين: كما أنّني هنا في أمانٍ معكَ؛ لا أنكر ذلك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأمير أكنان: أنتِ في أمان، ولكنَّكِ لستِ سعيدة!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جمانة: كيف أُسعَد وأنا أعيش كالجواري، في قصر كبير، ولكنْ من دون عائلتي؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأمير أكنان: أريد أنْ أُساعدَكِ؛ هلّا أخبرتِني باسمَي أُختَيْكِ وأوصافهما.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جمانة: كيف ستساعدني؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأمير أكنان: لي طريقتي الخاصّة؛ سأبعثُ مَنْ يبحث عنهما في كُلّ مكان من حولنا، لا أعتقدُ أنَّهما ابتعدتَا كثيرًا، فقط أخبريني.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فرحت جمانة فرحًا شديدًا، وشكرَت الأمير أكنان على نُبل أخلاقه، ثمّ هرولَت إلى العجوز تخبرُها وهي تكادُ تطير فرحًا، إلى درجة أنَّها لم تستطِع النَّوم.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وفى الأمير أكنان بوعده؛ فأرسل عدّةَ رجالٍ يطوفون المدن والبلاد المجاورة بحثًا عن أُختَي جمانة، استغرقَ ذلك وقتًا طويلًا لصعوبة التنقُّل بين تلك المدن والبلاد المجاورة، كان الأمر صعبًا جدًّا، كأنَّهم يبحثون في كومة من القش.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وصلَ أحدُ الرجال إلى المنطقة الَّتي تسكنُ فيها لؤلؤة، وأخذَ يسأل في السوق عن شابَّتَين: إحداهما تُدعى لؤلؤة، والأخرى صوفيا؛ فسمعَه بديع، وأمسكه من رقبته.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بديع: لماذا تسأل أيُّها الغريب؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الرّجل: أنا مُرسَل من الأمير أكنان.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بديع: مَنْ هذا الأمير أكنان؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الرّجل: أمير بلاد الظَّلام المجاورة لكُم.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بديع، بعدما أفلت الرّجل: ما سبب السؤال؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الرّجل: لا أعرف، ولكنْ مَنْ يستطيع معرفة مكان هاتين الشابتين أو إحداهما سيُعطيه الأمير أكنان مكافأة كبيرة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بديع، وقد لمعَت نظرةَ الخُبث في عينيه:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أنا أعرفُ مكانهما.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الرّجل: أحقًّا ما تقول؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بديع: نعم، ولكنْ تعال معي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("اصطحبَ بديع الرجل إلى بيته، ثمّ طلبَ من لؤلؤة إعداد الشاي لهُما، وأخذ يسأله أسئلة كثيرة، والرجل يقول له إنَّه لا يعرف شيئًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بديع: أنا زوج لؤلؤة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الرّجل، في فرح: أحقًّا ما تقول؟! أمَا لو كنتَ صادقًا فإنَّك محظوظ حقًّا!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("دخل بديع على زوجته لؤلؤة، ثمّ أخبرَها بأمر الرجل.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة تهلّلَ وجهها: رُبّما يعرف شيئًا عن جمانة، أو عن أبوَيّ، وإلّا كيف سيعرفنا؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بديع، بعد عودته إلى الرجل: ماذا تُريد منّا الآن؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الرّجل: أُريد أنْ تذهبَا معي غدًا إلى بلاد الظّلام.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بديع: نذهبُ، ولكنْ هل تريدني أنْ أُصدِّقَك وأذهب معك من دون مقابل؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أخرجَ الرجلُ صرّةَ نقود من جيبه ووضعَها في يد بديع، وأخبرَه بأنَّه سيكون صباح غد أمام الباب ليصحبهما معه إلى قصر الأمير أكنان.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وضعَت لؤلؤة رأسها على الوسادة، ولكنَّ النَّومَ قد فارقَها، وحلَّت مكانه أفكار كثيرة: يا تُرى؛ هل حقًّا لديه أخبار مفرحة؟! مَنْ هذا الرجل؟! هل هو حقًّا مُرسَل من الأمير أكنان، أم أنَّ وراءَه قصّة أخرى؟! هل وجدَ أبي وأُمّي وهما مَنْ يبحثان عنّي؟! هل وجدَ أُختي جمانة؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تعبَت من كثرةِ التَّفكير حتَّى غطَّت في نوم عميق، أمَّا بديع الجشع؛ فخبَّأ كيسَ النقود عنها، كما أنَّه غطَّ في نوم عميق منذ أنْ وضع رأسه على الوسادة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في الصّباح الباكر، كانَ الرَّجلُ واقفًا أمام الباب ينتظرهما، وانطلقوا في رحلة طويلة إلى أنْ وصلوا إلى بلاد الظَّلام مع غياب الشمس، ثمّ ما لبثَ القصر أنْ لاح لهم.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة: مَنْ يسكن هنا في هذا القصر الكبير؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الرّجل: إنّهُ قصرُ الأمير أكنان.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة: مَنْ هذا الأمير أكنان؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الرّجل: إنه أميرُ بلاد الظلام، إنَّهُ رجل طيِّب.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("دقَّ قلبُ لؤلؤة سريعًا وهي تنتظرُ ما سيحدث، أمّا بديع الجشع؛ فيفكِّر فيما سيحصل عليه مقابل إحضار لؤلؤة إلى هنا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("استأذنَ الرّجلُ حرسَ القصر؛ فأدخلوه؛ لأنَّه معروفٌ لديهم؛ إنَّهُ رسول الأمير! دخلَ بهما بهوَ القصر الَّذي كان يخلو من الخدم، كلُّهم في غرفهم، وقفَ الأمير أكنان يستقبلُ القادمين بعدما أبلغه الحرس، رحَّب بهما وسلّم عليهما وطلبَ منهما الجلوس، أخبرَه الرَّسول بأنَّه رأى هذا الرجلَ في السوق ببلاد النور، وأنَّه زوج لؤلؤة، وأنَّه يعرف مكان صوفيا؛ فأُعجب الأمير أكنان بالخبر، ونظر إلى الرجل، وقال له:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سنكافِئُكَ على هذه المعلومات المهمّة إنْ كنتَ صادقًا!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فلمعَت نظرةُ الجشع في عيني بديع، وابتسمَ ابتسامة صفراء، ثمّ نظر إلى لؤلؤة الَّتي كادَت تسقط من الخوف، إضافة إلى ما ينتظرها من مفاجآت.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأمير أكنان: هل لي أنْ أسألَكِ يا سيدتي؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة، وهي تُطأطئ رأسها: تفضَّل يا مولاي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأمير أكنان: مِن أينَ أنتِ؟ هل لديكِ أخوات؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أرادَ بديع الإجابة، ولكنَّ الأمير أكنان أشار إليه بالسكوت.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة: من بلاد القمر المضيء، نعم؛ لديَّ أُختان، وهما جمانة وصوفيا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأمير أكنان، يبتسمُ: هل لي بلحظة؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ذهب الأمير أكنان إلى جمانة، وقال لها:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لديَّ مفاجأة لكِ.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أحضر الأمير أكنان معه جمانة وهي تهرولُ؛ فأدخلَها على لؤلؤة؛ فصرخَت من الفرحة، ورمَت بنفسها في حضنِها، ولم تكفَّا عن البكاء.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("انسحبَ الأمير أكنان خارجًا، كما أشارَ إلى بديع بالخروج.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تعانقَت الأُختان لؤلؤة وجمانة مدّة ليست بالقصيرة ودموعهما تجري كالشلال بسرعة ولا يريد أنْ يوقفه أحد، ثمّ جلستَا جلسة طويلة تتحادثان في كُلِّ ما جرى لهما من أحداث منذ إغارة قطَّاع الطّرق عليهم، أخبرَتها جمانة بأنَّ الأمير أكنان طيّب القلبِ، وأنَّه هو الَّذي عرض عليها البحث عن أُختَيْها، كما أنَّهُ لم يُؤذِها قط، وأخبرَتْها لؤلؤة بأنّها تعيش في البلاد نفسها الَّتي تعيشُ فيها صوفيا، وأنَّها أصبحَت زوجة الأمير باهر.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جمانة بدهشة: ماذا تقولين؟! زوجة الأمير باهر؟! كيف ذلك؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة: سأحكي لكِ كلّ شيء في الطّريق.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جمانة: في الطريق!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة: نعم؛ لا بدَّ أنْ تذهبي معنا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جمانة: نعم؛ أُريدُ أنْ أعود معكم، ولكنْ لا بُدَّ مِن أنْ أستأذن الأمير أكنان، إنَّهُ يحترمني كثيرًا، وساعدني على الوصول إليكِ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة: حسنًا؛ اذهبي واستأذنيه، سنعودُ صباح غد.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ذهبَت جمانة إلى الأمير أكنان؛ فأخبرته بأنَّها تُريد الذَّهاب مع أُختها؛ تغيَّر وجههُ قليلًا، هو يعلمُ بأنَّها ستتركُ هذا المكان عاجلًا أو آجلًا، ولكنْ ليس بهذه السرعة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأمير أكنان: هلّا انتظرتِ قليلًا، اطلبي من أُختكِ البقاء هنا مدّة ما ثمّ الرحيل.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جمانة: لا تستطيعُ؛ فلدى زوجها عمل، كما أنَّني أريدُ أنْ أرى صوفيا؛ إنَّها هناك أيضًا، يحزنني تركُكَ، وأرجو أنْ تكون سعيدًا دائمًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأمير أكنان: كما تشائين، في صباح غد سأبعث معكم بقافلة محمّلة بالهدايا لكم ولأهلكم.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جمانة: شكرًا لك يا مولاي، لقد مكثت هنا مدة طويلة، ولن أنساكَ أو أنسى خالتي العجوز، سأزوركُم إنْ سنحَت لي الفرصة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم ينسَ الأمير أكنان بديعًا؛ فقَد أعطاهُ صرّةً كبيرة من المال، فرحَ بها كثيرًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في الصّباح، نادى الأمير أكنان الخدمَ، فجهّزوا القافلةَ، وتحرّكت بهم بعدما ودّعوا الأمير، وابتعدت القافلةُ وهم يلوّحون له، ظلَّت أيدي الأُختين مُتشابكة طوال الطريق من شدَّة الفرح واللقاء بعد الفراق، ولكنْ لا يزال عدم الاهتداء إلى أبوَيهما يؤرّقهما.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وصلَت القافلةُ إلى بيت بديع؛ فأنزلوا كُلَّ الهدايا وهو يكادُ يقفز فرحًا، ودَّعهم، ورجعَت القافلةُ إلى بلاد الظّلام.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أدخلَت لؤلؤة أُختها جمانة غرفتها كي ترتاح؛ فهما كانتا متعبتين جدًّا، حتَّى إنَّهما لم تجوعا ولم تُفكِّرا في الطّعام قط، أرادتَا فقط النوم والراحة، ووعدتها لؤلؤة بأنْ تأخذها لرؤية صوفيا في اليوم التالي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة: هل تعلمين أنَّ صوفيا أصبحَت أُمًّا؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جمانة: حقًّا؟! كم أنا مشتاقة إلى رؤيتها!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بديع من شدَّة الفرح لم يطلب من لؤلؤة إعداد الطعام له، بل خرجَ من فوره إلى السوق ليأكل ما تشتهيه نفسه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("شقَّ الصباح نوره، وتعالَت أصوات العصافير مزقزقةً، وفتحَت الأُختان أعينهما وتعانقتا من جديد، نهضتَا واغتسلتَا بعد عناء السفر، وطلبَت جمانة من لؤلؤة الإسراع في رؤية صوفيا، ولكنَّها أخبرَتها بأنَّهُ لا بدَّ من الذهاب مع نُهيرة؛ فالحرسُ يعرفونها جيدًا ولن تتعبَا في دخول القصر.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ذهبتَا إلى نُهيرة وعرَّفتها لؤلؤة بأُختها جمانة، فدُهشت لجمالِها، وأخبرتها بأنَّهما مُتشابهتان إلى حدٍّ كبير، كما أخبرتها كيف وصلَت إليها، ولم يبقَ إلّا الاجتماع بأُختيهما الصغرى لتعمهنَّ الفرحة كما في السابق.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حضرَ بديع، وطلبنَ منه إيصالهنَّ إلى القصر؛ فحملهنَّ الثلاث وذهب بهنَّ يشقُّ الطريق شقًّا، ما إنْ وصلوا حتَّى تأكَّد الحرس منهم جميعًا: بديع معروف لديهم؛ فهو مَن يُحضِر الخضار إلى القصر، ونُهيرة خادمة قديمة فيه، سمحوا لهم بالدخول، وما إنْ ولجوا القصرَ حتَّى استأذنت لؤلؤة إحدى الجواري بأنْ تنادي نائلة؛ المساعدة الشخصية، حضرَت وهي مدهوشة لهذه الزيارة وفي هذا الوقت! سلَّمت عليها لؤلؤة، وقدَّمت إليها أُختها جمانة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة، وهي تفتح فاهها دهشةً: أُختكِ! جمانة!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة: نعم، ونحن هنا لرؤية صوفيا، ولكنْ لا نريدُ أنْ نفاجئَها كي لا تفزع؛ لأنَّها لا تعلم بما حدثَ؛ فقد كنتُ عندكم منذ أيّام قليلة، وتطوّرتِ الأحداث بسرعة، وها هي جمانة أمامنا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة: وماذا تريدين مني أنْ أفعل؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة: تُمهدّين لـصوفيا بأنَّني هُنا ولديَّ مفاجأة سعيدة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة: حسنًا؛ سأفعلُ، انتظراني هنا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ذهبَت نائلة إلى صوفيا، وتحدَّثت إليها قليلًا، ثمَّ أخبرتها بأنَّ لؤلؤة تنتظرها في غرفة الضيوف.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا، تصرخُ: لماذا لم تخبريني من قبل؟! تتحدّثين وتتحدَّثين كأنَّهُ لا أحد ينتظرني!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة: آسفة، ولكنْ هي ليسَت وحدها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا: ليست وحدها! مَنْ معها؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة: معها فتاة غريبة لا أعرفُها! ولكنْ...")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا: ولكنْ ماذا؟ تحدَّثي!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نائلة: إنَّها تشبهكِ!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا: ماذا تقولين؟ تشبهني!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أسرعَت صوفيا تخطو بخطوات سريعة في ممرّات القصر والأفكار تتراقص في رأسها، وحينما وصلت إلى غرفة الضيوف وقفَت تريد فتح الباب، ولكنّ يدها ترتجف، فتحَته بقوّةٍ، فإذا بـلؤلؤة وجمانة أمامها، صرخَت بأعلى صوتها:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جمانة! أُختي، حبيبتي، أين كنتِ؟! لقد اشتقت إليكِ كثيرًا!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جمانة لا تفتح فاهها بكلمة، فقط تريدُ أنْ تأخذ الشوق كلّه من صدرِ صوفيا بعناقِها القوي لها وهي مغمضة العينين.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أمسكَت لؤلؤة بوجنتَيها وهي تقول:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أخيرًا اجتمعنا، الحمد لله على هذه النعمة، سنوات عدّة ونحن ننتظر هذا اليوم!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وقفَت بينهما لتكوِّن حضنًا كبيرًا بقدر الشوق الَّذي في صدورهنّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جلست الأخوات ساعات عدّة يحكينَ لبعضهنَّ بعضًا ما حدث لهنَّ طوال تلك السنوات، وطلبَت صوفيا من أُختَيها لؤلؤة وجمانة العيشَ معها في القصر؛ فالأمير لا يرفض لها طلبًا، وافقَت جمانة؛ لأنَّها لا مكان لها ولا زوج، أمَّا لؤلؤة؛ فترجو الله تعالى الفرار من عند بديع لتعيش معهما؛ إنّهُ جشع؛ لا يُفكِّر إلّا في المال!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("صوفيا: إذًا نُعطيه المال بشرط أنْ يطلقكِ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لؤلؤة: حسنًا؛ سأعودُ إلى البيت وأعرض عليه أنْ يطلّقَني مُقابل المال، وأظنُّ أنّه لن يرفض.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مكثت جمانة مع صوفيا أيّامًا معدوداتٍ، قبل أنْ ترجعَ إليهما لؤلؤة ومعها بديع ينتظرُ في الخارج المالَ كي يُطلّق.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أخبرَت صوفيا الأميرَ باهرًا بكُلِّ شيء؛ فوافقَ على أن تعيش أُختَاها معها في القصر، وأعطاها مالًا لكي تدفعه إلى بديع الجشع؛ فأرسلَته إليه مع أحدِ الحُرَّاس، الَّذي أعطاه إيّاه، وطلبَ منه المغادرة وعدم العودة إلى هذا المكان مرة أُخرى وإلّا قُطع رأسه، أخذَ بديعٌ المال وفرَّ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قضت الأخواتُ أيّامًا ولياليَ كثيرةً في فرح وأُنس وذكريات، بعضها سعيد وبعضها أليم، ولكنْ لا يزال فَقْدُ أبوَيهما يُحزنهنّ كثيرًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("طلبَت صوفيا من الأمير باهر أنْ يبعثَ رجاله للبحث عن أبوَيهما مرةً أخرى؛ فرُبّما لا يزالان على قيد الحياة؛ فوافقَ، ثمّ أرسلَ جنوده الثّقات للبحث عنهما.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مضَت أشهرٌ عدّة ولا خبر يلوح في الأفق.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في يومٍ ما، رجع رسول الأمير أكنان إلى بيت بديع، ثمّ طرقَ الباب؛ فلم يفتح له أحد، عادَ مرّة أخرى ففتح له، وأخبره بأنّهُ مُرسَل من الأمير ليُوصل رسالة إلى جمانة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بديع: ليست هنا، إنَّها تعيش في القصر.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الرّسول، بدهشةٍ: القصر!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بديع: نعم، ولا يستطيعُ أنْ يأخذكَ إلى هناك إلّا نُهيرة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الرّسول: نُهيرة! مَنْ نُهيرة؟! أينَ أجدها؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أخذ بديع رسول الأمير أكنان إلى نُهيرة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الرّسول: أنا رسول الأمير أكنان، ولديَّ رسالة إلى جمانة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نُهيرة: أعطِني الرِّسالة وأنا مَنْ سيوصلها إليها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الرّسول، يرفضُ قائلًا: إنّها رسالة شفهيَّة، ومن الممنوع أنْ يستمِع إليها غير جمانة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نُهيرة: جمانة أخت لـصوفيا؛ زوجة الأمير باهر، وتعيش في قصرهما، سنأخذك إليها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("طلبَا من بديع أنْ يوصلهما، ولكنَّهُ خافَ ورفض.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الرّسول: لا عليكِ؛ سنذهب أنا وأنتِ، هل تعرفين الطريق؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نُهيرة: نعم؛ أعرفهُ جيدًا، عملتُ سنواتٍ طويلة هناك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ذهبَ الرّسول ونُهيرة إلى القصر، ثمَّ استأذنَا لرؤية جمانة وحدها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الرّسول: أنا رسول الأمير أكنان، ولديَّ رسالة شفهية منهُ إليكِ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("جمانة: هاتِ ما عندك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الرّسول: يقول الأمير أكنان إنَّ القصرَ أصبحَ خاويًا منذُ غادرتِه، فهلّا رجعتِ؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فُوجئت جمانة برسالة الأمير أكنان، هل ما كان بين الأمير أكنان وجمانة حبّ أم عطف؟! هي تحبُّه، ولكنْ لا تجرؤ على الإفصاح عن ذلك، مَنْ هي كي يحبَّها هو؟! حينما سمح لها بالرحيل تأكَّدت مِن أنَّ ذلك كان عطفًا؛ فلو كانَ يحبُّها لمَا سمح لها بالرحيل، ولكنّه الآن يريدها أنْ تعود!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أرسلَت جمانة مع الرسول رسالةً إلى الأمير أكنان:")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أصبحَ فؤادي خاويًا منذُ غادرتُ قصركَ.")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عادَ الرّسولُ إلى الأمير أكنان، ثمّ أسمعَهُ الرسالةَ، كادَ يطيرُ فرحًا لكلماتها، تخيَّلها بصوتها العذب الَّذي افتقده كثيرًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الرّسول: هل تعلمُ بأنَّها أختٌ لزوجة الأمير باهر؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأمير أكنان: حقًّا؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("شكرَ الأمير أكنان الرسولَ كثيرًا، وجلسَ يُفكِّر في كيفيَّة الذهاب إليها؛ فهو منذُ كانَ صغيرًا لم يُغادر بلادَ الظَّلام، ولكنْ لا بُدَّ له من أنْ يتغيَّر، أنْ يذهب إليها؛ فهو مَن سمحَ لها بالرحيل، كما أنَّهُ لم يجرؤ على مصارحتها بحبّه لها منذ أنْ رآها في حديقة القصر أوّل مرّة، يجبُ أنْ يعرف الأمير باهر بهذه الزيارة الرسمية.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أرسلَ الأمير أكنان الرسولَ إلى إيهاب؛ وزير الأمير باهر، يخبره بأنَّ الأمير أكنان يريدُ زيارته والتحدُّث إليه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("استعدَّ الأمير أكنان للذهاب مع قافلة كبيرة محمّلة بشتَّى الهدايا إلى بلاد الشمس الساطعة؛ كي يخطبَ جمانة من الأمير باهر، وهذا ما حدثَ، عمّهم جميعًا الفرح، وأُقيمَت الاحتفالات بخطبتهما.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ودّعت جمانة أُختَيْها مرّة أخرى، ولكنْ هذه المرَّة بفرحٍ وسعادة، ثمّ غادرت والأمير أكنان إلى بلاد الظَّلام، حيث أُقيمَ لهما حفل كبير يليق بهما.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأبوان لا يزالان مفقودَين؛ هل لقيا مصرعهما في تلك الحادثة، أم أنّهما في مكان ما لا يعلمه أحد؟!")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- للقصَّة بقية -")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdde7154","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0001.vue
// module id = 78
// module chunks = 0